/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  DownloadOutlined,
  EyeOutlined,
  FieldTimeOutlined,
  FilePdfOutlined,
  InfoCircleOutlined,
  PrinterOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';
import {
  Alert,
  Button,
  Card,
  Col,
  DatePicker,
  Empty,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select as AntSelect,
  Spin,
  Table as AntTable,
  Tabs,
  Tag,
  TimePicker,
  TreeSelect,
  Typography,
  Upload,
} from 'antd';
import dayjs from 'dayjs';
import { getCaracteresDeNombramiento } from 'api/catalogos/CaracterDeNombramiento';
import { getMotivosDeMovimientosDeEmpleados } from 'api/catalogos/motivoDeMovimientoDeEmpleados';
import { getMotivosDeLiquidaciones } from 'api/catalogos/motivosDeLiquidaciones';
import {
  getNombramientosvistaoptimized, deleteNombramiento, postDarVistoBuenoMasivo,
  patchNombramientoDocumentoEvidencia, getNombramiento, patchNombramiento,
} from 'api/catalogos/Nombramientos';
import getProcesoEnCursoTerminado from 'api/catalogos/ProcesoEnCursoTerminado';
import {
  deleteDatoOperacionalDelEmpleado,
  getDatoOperacionalesDeEmpleados,
} from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import {
  deleteEmpleado,
  getEmpleadosvistaOptimized,
} from 'api/estructuraOrganizacional/empleados';
import { getLiquidaciones } from 'api/nominas/liquidaciones/liquidaciones';
import { postObtenerReporte } from 'api/reporteador';
import { checkToken } from 'api/utils';
import CurrencyInput from 'components/CurrencyInput';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ReportViewer from 'components/ReportViewer';
import Select from 'components/Select';
import Table from 'components/Table';
import moment from 'moment/moment';
import currencyFormatter from 'utils/currencyFormatter';
import React, {
  useCallback, useEffect, useMemo, useRef, useState,
} from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { selectUser } from 'store/auth';
import API from 'utils/api';
import { formatReceivedValues } from 'utils/formatValues';
import { onAlert, onError } from 'utils/handlers';
import { getModelPermission, hasActionPermission } from 'utils/permission';
import { getNombramientosTiposDeContrataciones } from 'api/catalogos/NombramientosTipoContratacion';
import { getConfiguradorNombramientosFormato } from 'api/catalogos/ConfiguradorNombramientosFormato';
import { getLimitacionesAutorizacionNombramientos } from 'api/usuarios/limitacionAutorizacionNombramientos';
import {
  postFirmarNombramientoMasivo, postImprimirNombramientoMasivo,
  postSubirPdfNombramientoFea, getConsultarFirmaNombramientoFea,
  getBitacoraFirmaElectronica,
} from 'api/nominas/firmaElectronica';
import { obtenerMiPasoDeAutorizacion } from 'utils/pasoAutorizacion';
import { obtenerEstadoFirmanteFEA } from 'utils/firmanteFEA';
import { getTiposDeMovimientoDePersonal } from 'api/catalogos/tiposDeMovimientoDePersonal';
import NombramientosTipoContratacion, { NombramientosTipoContratacionPermission } from './NombramientosTipoContratacion';

const { TabPane } = Tabs;

const PERIODICIDAD_OPCIONES = [
  { value: 'quincenal', label: 'Quincenal (15 días)' },
  { value: 'mensual', label: 'Mensual' },
  { value: 'bimestral', label: 'Bimestral (2 meses)' },
  { value: 'trimestral', label: 'Trimestral (3 meses)' },
  { value: 'semestral', label: 'Semestral (6 meses)' },
  { value: 'anual', label: 'Anual (12 meses)' },
];

const PERIODICIDAD_MESES = {
  quincenal: null,
  mensual: 1,
  bimestral: 2,
  trimestral: 3,
  semestral: 6,
  anual: 12,
};

export const onErrorFields = (
  err,
  setLoading = null,
  formsInstances = [],
  setCurrentTabKey,
  setCurrentTabKeyDO,
  setCurrentParentTabKey,
) => {
  if (typeof setLoading === 'function') {
    setLoading(false);
  }
  const errorKeys = err.errorFields.map((e) => e.name[0]);
  const formWithErrors = formsInstances.find(
    (obj) => obj.tabFields.some(
      (val) => errorKeys.includes(val),
    ),
  );
  if (formWithErrors) {
    setTimeout(() => {
      if (typeof setCurrentTabKey === 'function') {
        switch (formWithErrors.parentTabKey) {
          case 'operativos':
            setCurrentTabKeyDO(formWithErrors.tabKey);
            break;
          case 'pago':
            break;
          default:
            setCurrentTabKey(formWithErrors.tabKey);
        }
        setCurrentParentTabKey(formWithErrors.parentTabKey);
      }
    });
  }
};

export const ConsultasNombramientosPermission = {
  permissionModel: 'empleado',
  catalogsModels: [
    'estadodelempleado',
    'genero',
    'estadocivil',
    'puesto',
    'centrodecostos',
    'formadepago',
  ],
};

const ConsultasDeNombramientos = ({ permission }) => {
  const currentUser = useSelector(selectUser);
  const [form] = Form.useForm();
  const [formOperacionales] = Form.useForm();
  const [formDireccion] = Form.useForm();
  const [formPlazas] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const preserveSelectionRef = React.useRef(false);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [visibleAlertNombramiento, setVisibleAlertNombramiento] = useState(false);
  const [visibleAlertVistoBueno, setVisibleAlertVistoBueno] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [estadosEmpleado, setEstadosDeEmpleado] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [paises, setPaises] = useState([]);
  const [estados, setEstados] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [tiemposDeContrataciones, setTiemposDeContrataciones] = useState([]);
  const [jornadas, setJornadas] = useState([]);
  const [nacionalidades, setNacionalidades] = useState([]);
  const [estadoCivil, setEstadoCivil] = useState([]);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [currentTabKeyDO, setCurrentTabKeyDO] = useState('adscripcion');
  const [currentParentTabKey, setCurrentParentTabKey] = useState('general');
  // const [datosPago, setDatosPago] = useState([]);
  const [disableEstatus, setDisableEstatus] = useState(true);
  const [isBlocked, setIsBlocked] = useState(false);
  const [nominaDisplay, setNominaDisplay] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentFilters, setCurrentFilters] = useState(null);
  const [selectedData, setSelectedData] = useState({});
  const showModal = () => {
    form.resetFields(); //  limpia los campos del formulario de búsqueda
    setIsModalVisible(true); // abre el modal
  };

  const puedeEditarNombramiento = hasActionPermission('nombramiento', 'editar');

  const [caracterdenombramiento, setCaracterDeNombramiento] = useState([]);
  const [motivosBaja, setMotivosBaja] = useState([]);
  const [isModalNombramientoMasivoVisible, setIsModalNombramientoMasivoVisible] = useState(false);
  const [periodosNombramiento, setPeriodosNombramiento] = useState([]);
  const [isModalAutorizarVisible, setIsModalAutorizarVisible] = useState(false);
  const [rawEmpleados, setRawEmpleados] = useState([]);
  const [pasoAutorizacionNombramiento, setPasoAutorizacionNombramiento] = useState(null);
  const [firmanteFEAInfo, setFirmanteFEAInfo] = useState(null);
  const [formNombramiento] = Form.useForm();
  const [formAutorizar] = Form.useForm();
  const [isModalRenovarVisible, setIsModalRenovarVisible] = useState(false);
  const [formRenovar] = Form.useForm();
  const [isModalBajaVisible, setIsModalBajaVisible] = useState(false);
  const [formBaja] = Form.useForm();

  const [isModalFirmarVisible, setIsModalFirmarVisible] = useState(false);
  const [formFirmar] = Form.useForm();
  const [archivoCertificado, setArchivoCertificado] = useState(null);
  const [archivoKey, setArchivoKey] = useState(null);
  const [loadingFirmar, setLoadingFirmar] = useState(false);
  // Filtro dinámico por firmante pendiente, solo para el tab Pendientes de Firma
  const [filtroFirmante, setFiltroFirmante] = useState('todos');
  const [subTabFirma, setSubTabFirma] = useState('pendientes');
  // Filtro dinámico por Tipo de Contratación, disponible en todos los tabs con tabla de datos
  const [filtroTipoContratacion, setFiltroTipoContratacion] = useState('todos');

  // Evidencia de firma (PDF escaneado/firmado fuera de FEA) — Excel punto 2e
  const [isModalEvidenciaVisible, setIsModalEvidenciaVisible] = useState(false);
  const [archivoEvidencia, setArchivoEvidencia] = useState(null);
  const [loadingEvidencia, setLoadingEvidencia] = useState(false);

  // Consultar estado de firma FEA
  const [isModalConsultaFEAVisible, setIsModalConsultaFEAVisible] = useState(false);
  const [consultaFEAData, setConsultaFEAData] = useState(null);
  const [loadingConsultaFEA, setLoadingConsultaFEA] = useState(false);

  // Subir PDF a FEA
  const [isModalSubirPdfFEAVisible, setIsModalSubirPdfFEAVisible] = useState(false);
  const [archivoPdfFEA, setArchivoPdfFEA] = useState(null);
  const [loadingSubirPdfFEA, setLoadingSubirPdfFEA] = useState(false);
  const [dataBitacora, setDataBitacora] = useState([]);
  const [loadingBitacora, setLoadingBitacora] = useState(false);

  const [isModalProgresoVisible, setIsModalProgresoVisible] = useState(false);
  // Polling de operaciones en background (patrón CalculosDeNomina)
  const [isPolling, setIsPolling] = useState(false);
  const [pollingSnapshot, setPollingSnapshot] = useState(null);
  const [pollingOnCerrar, setPollingOnCerrar] = useState(null);
  const pollingRef = useRef(null);
  // Contador de progreso leído desde ProcesoEnCursoTerminado
  const [progresoActual, setProgresoActual] = useState({ en_curso: 0, total: 0 });
  // Registros actualmente visibles en la tabla (tras filtros de columna de Ant Design)
  const [currentTableData, setCurrentTableData] = useState([]);
  // Datos exclusivos del tab Empleados (desde empleados-vista-optimized)
  const [dataEmpleados, setDataEmpleados] = useState([]);
  const [base64, setBase64] = useState();
  const [visiblePreview, setVisiblePreview] = useState(false);
  const [tiposDeMovimientoDePersonal, setTiposDeMovimientoDePersonal] = useState([]);
  const [estadosNombramiento, setEstadosNombramiento] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [refrescandoConFiltro, setRefrescandoConFiltro] = useState(false);
  const [motivosLiquidacion, setMotivosLiquidacion] = useState([]);
  const [aplicaFiniquito, setAplicaFiniquito] = useState(false);
  const [catMotivosLiquidacion, setCatMotivosLiquidacion] = useState([]);
  const [updateFetch, setUpdateFetch] = useState(false);
  const [nombramientosTiposDeContrataciones, setNombramientosTiposDeContrataciones] = useState([]);

  const TAB_TIPODECONTRATACION = 'tipo_de_contratacion';
  const TAB_EMPLEADOS = 'empleados';
  const TAB_AUTORIZACION = 'autorizacion';
  const TAB_PENDIENTE_FIRMA = 'pendiente_firma';
  // Sub-tabs dentro de "Firma": Pendientes por Firmar/Autorizar (estado 7) y
  // Pendientes Imprimir (estado 8, PENDIENTE DE IMPRESIÓN -- ya completaron
  // todos sus firmantes/confirmantes, ver firmar_nombramiento_masivo).
  const SUBTAB_FIRMA_PENDIENTES = 'pendientes';
  const SUBTAB_FIRMA_IMPRIMIR = 'imprimir';
  const TAB_VIGENTES = 'vigentes';
  const TAB_RENOVACION = 'renovacion';
  const TAB_NO_VIGENTES_PENDIENTES = 'no_vigentes_pendientes';
  const TAB_NO_VIGENTES = 'no_vigentes';
  const TAB_BAJA = 'baja';
  const TAB_BITACORA_FIRMA = 'bitacora_firma';
  const TAB_IMPRIMIR = 'imprimir';

  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') === 'renovacion' ? TAB_RENOVACION : TAB_TIPODECONTRATACION;
  const [activeTab, setActiveTab] = useState(initialTab);

  const baseURI = 'nominas/nombramientos';

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => {
        const flat = formatReceivedValues(e);
        return {
          ...flat.empleado,
          ...flat,
          id: flat.empleado?.id || flat.id,
        };
      });

      valueClone = valueClone.map((e) => ({
        ...e,
        puesto: e?.puesto ?? '',
        tipoDeNominaEmpleado: e?.tipoDeNominaEmpleado ?? '',
        area: e?.area ?? '',
        plaza: e?.plaza ?? '',
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      const [_data, _empleados, _nombramientosTiposDeContrataciones] = await Promise.all([
        getNombramientosvistaoptimized(),
        getEmpleadosvistaOptimized(),
        // estados_globales=4 (Autorizado): solo tipos de contratación activos/autorizados
        getNombramientosTiposDeContrataciones({ estados_globales: 4 }),
      ]);

      setNombramientosTiposDeContrataciones(_nombramientosTiposDeContrataciones);

      // ── Tabs de nombramientos (Autorización, Vigentes, etc.) ──────────────
      let filtrados = _data.filter((e) => (e.plaza_id !== null && e.plaza !== null) || e.nombramiento_estado_nombramiento_id === 4);
      if (_nombramientosTiposDeContrataciones?.length) {
        filtrados = filtrados?.filter((e) => (
          e.nombramiento_estado_nombramiento_id === 4
          || _nombramientosTiposDeContrataciones.some((n) => (e?.tipo_de_contratacion_id === n?.tipo_de_contratacion))
        ));
      }
      setData(filtrados);
      setOriginalData(filtrados);

      // ── Tab Empleados: empleados-vista-optimized filtrado ─────────────────
      // IDs de tipo_de_contratacion autorizados (estados_globales=4)
      const tiposContratacionAutorizados = new Set(
        (_nombramientosTiposDeContrataciones || []).map((n) => n.tipo_de_contratacion),
      );

      // IDs de empleados con nombramiento en curso (ACTIVO=1, PENDIENTE POR FIRMAR=7, VIGENTE=2) — no disponibles
      const idsConNombramientoActivo = new Set(
        _data
          .filter((e) => e.nombramiento_estado_nombramiento_id === 1
            || e.nombramiento_estado_nombramiento_id === 7
            || e.nombramiento_estado_nombramiento_id === 2)
          .map((e) => e.id),
      );

      // Empleados disponibles para nombramiento:
      //   1. Sin nombramiento activo/vigente
      //   2. Con tipo_de_contratacion_id dentro de los autorizados (si hay configuración)
      const empleadosDisponibles = (_empleados || []).filter((e) => {
        if (!e.plaza_id) return false;
        if (idsConNombramientoActivo.has(e.id)) return false;
        if (tiposContratacionAutorizados.size > 0
          && !tiposContratacionAutorizados.has(e.tipo_de_contratacion_id)) return false;
        return true;
      });
      setDataEmpleados(empleadosDisponibles);
    } catch (err) {
      message.error('Error al cargar los datos');
    } finally {
      setLoading(false);
    }
  };

  // Actualiza cada que se actualiza nombramientos tipo contratacion, y también
  // al cambiar de tab, para que las tablas siempre reflejen el dato más reciente.
  useEffect(() => {
    fetchData();
  }, [updateFetch, activeTab]);

  useEffect(() => {
    obtenerMiPasoDeAutorizacion(getLimitacionesAutorizacionNombramientos)
      .then(setPasoAutorizacionNombramiento);
  }, []);

  useEffect(() => {
    obtenerEstadoFirmanteFEA(getLimitacionesAutorizacionNombramientos)
      .then(setFirmanteFEAInfo);
  }, []);

  const requiereObservacionesNombramiento = !!pasoAutorizacionNombramiento?.requiere_observaciones;

  useEffect(() => {
    let mounted = true;

    const fetchAll = async () => {
      try {
        setLoading(true);
        await checkToken();

        const [
          _motivosBaja,
          _caracteresNombramiento,
          _motivosLiquidacion,
          _catMotivosLiq,
          _tiposMovPersonal,
        ] = await Promise.all([
          getMotivosDeMovimientosDeEmpleados(),
          getCaracteresDeNombramiento(),
          getLiquidaciones(),
          getMotivosDeLiquidaciones(),
          getTiposDeMovimientoDePersonal({ estados_globales: 4 }),
        ]);

        if (mounted) {
          await fetchData();
          setMotivosBaja(_motivosBaja);
          setCaracterDeNombramiento(_caracteresNombramiento);
          setMotivosLiquidacion(_motivosLiquidacion);
          setCatMotivosLiquidacion(_catMotivosLiq);
          setTiposDeMovimientoDePersonal(Array.isArray(_tiposMovPersonal) ? _tiposMovPersonal : _tiposMovPersonal?.results || []);

          // Verificar si hay un proceso en curso al entrar a la página
          const procesosConocidos = [
            { descripcionProceso: 'Agregar Nombramiento', operacion: 'Agregar Nombramiento' },
            { descripcionProceso: 'Baja Nombramiento', operacion: 'Baja Nombramiento' },
            { descripcionProceso: 'Autorizar Nombramiento', operacion: 'Autorizar Nombramiento' },
          ];
          const resultadosProcesos = await Promise.all(
            procesosConocidos.map(async (desc) => {
              const lista = await getProcesoEnCursoTerminado({ descripcion: desc.descripcionProceso });
              return { desc, proceso: lista[0] };
            }),
          );
          const procesoActivo = resultadosProcesos.find(
            ({ proceso }) => proceso && proceso.procesando === true,
          );
          if (procesoActivo) {
            setProgresoActual({
              en_curso: procesoActivo.proceso.registro_en_curso || 0,
              total: procesoActivo.proceso.total_registros || 0,
            });
            setPollingSnapshot(procesoActivo.desc);
            setIsModalProgresoVisible(true);
            setIsPolling(true);
          }
        }
      } finally {
        setLoading(false);
      }
    };

    fetchAll();

    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    if (!originalData?.length) return;

    let filtered = [];

    switch (activeTab) {
      case TAB_EMPLEADOS:
        // El tab Empleados usa dataEmpleados (empleados-vista-optimized), no originalData
        return;

      case TAB_AUTORIZACION:
        // Tienen nombramiento y su estatus es ACTIVO (ID 1)
        filtered = originalData.filter(
          (item) => item.nombramiento_estado_nombramiento_id === 1,
        );
        break;

      case TAB_PENDIENTE_FIRMA:
        // Sub-tab "Pendientes por Firmar/Autorizar": PENDIENTE POR FIRMAR (ID 7).
        // Sub-tab "Pendientes Imprimir": PENDIENTE DE IMPRESIÓN (ID 8) — ya
        // completaron todos sus firmantes/confirmantes, falta imprimir.
        filtered = originalData.filter(
          (item) => item.nombramiento_estado_nombramiento_id === (
            subTabFirma === SUBTAB_FIRMA_IMPRIMIR ? 8 : 7
          ),
        );
        break;

      case TAB_VIGENTES:
        // Estado VIGENTE (ID 2)
        filtered = originalData.filter(
          (item) => item.nombramiento_estado_nombramiento_id === 2,
        );
        break;

      case TAB_RENOVACION:
        // OJO AQUÍ: Como "Renovación" no existe en tu catálogo de estatus (imagen),
        // probablemente sigan siendo VIGENTES (ID 2) pero necesitas validar si la
        // fecha 'nombramiento_termino_de_vigencia' está próxima a vencerse.
        // Por ahora lo dejamos filtrando por si el backend manda una bandera o texto:
        filtered = originalData.filter(
          (item) => item.nombramiento_estado_nombramiento_id === 2 && item.nombramiento_alerta_de_renovacion === true,
        );
        break;

      case TAB_NO_VIGENTES_PENDIENTES:
        // No Vigentes pendientes por dar de Baja (ID 6, aplico_baja = false)
        filtered = originalData.filter(
          (item) => item.nombramiento_estado_nombramiento_id === 6
            && item.nombramiento_aplico_baja === false,
        );
        break;

      case TAB_NO_VIGENTES:
        // No Vigentes que ya pasaron por proceso de Baja (ID 3)
        filtered = originalData.filter(
          (item) => item.nombramiento_estado_nombramiento_id === 3,
        );
        break;

      case TAB_BAJA:
        // Tienen nombramiento y su estatus es BAJA (ID 4)
        filtered = originalData.filter(
          (item) => item.nombramiento_estado_nombramiento_id === 4,
        );
        break;

      default:
        filtered = originalData;
    }

    // Actualizamos la tabla y limpiamos la selección (salvo que se indique preservar)
    setData(filtered);
    if (!preserveSelectionRef.current) {
      setSelectedRowKeys([]);
    }
    preserveSelectionRef.current = false;
    setCurrentTableData([]);
  }, [activeTab, originalData, subTabFirma]);

  // Al salir del sub-tab "Pendientes por Firmar/Autorizar", resetea el filtro por firmante
  useEffect(() => {
    if (activeTab !== TAB_PENDIENTE_FIRMA || subTabFirma !== SUBTAB_FIRMA_PENDIENTES) {
      setFiltroFirmante('todos');
    }
  }, [activeTab, subTabFirma]);

  // Al cambiar de tab resetea el filtro por Tipo de Contratación, ya que cada
  // tab tiene su propio dataset (Empleados, Pendientes de Firma, etc.)
  useEffect(() => {
    setFiltroTipoContratacion('todos');
  }, [activeTab]);

  useEffect(() => {
    if (activeTab !== TAB_BITACORA_FIRMA) return undefined;
    let mounted = true;
    const fetchBitacora = async () => {
      setLoadingBitacora(true);
      try {
        const res = await getBitacoraFirmaElectronica();
        if (mounted && res?.results) {
          setDataBitacora(res.results);
        } else if (mounted && Array.isArray(res)) {
          setDataBitacora(res);
        }
      } finally {
        if (mounted) setLoadingBitacora(false);
      }
    };
    fetchBitacora();
    return () => { mounted = false; };
  }, [activeTab]);

  // Opciones del filtro: se arman solo con los firmantes que de verdad
  // aparecen en los nombramientos pendientes de firma (dinámico, no tabs fijos).
  const opcionesFiltroFirmante = useMemo(() => {
    if (activeTab !== TAB_PENDIENTE_FIRMA || subTabFirma !== SUBTAB_FIRMA_PENDIENTES) return [];
    const nombres = [];
    data.forEach((row) => {
      (row.nombramiento_firmantes || []).forEach((f) => {
        if (!nombres.includes(f.nombre)) nombres.push(f.nombre);
      });
    });
    return [
      { value: 'todos', label: `Todos los pendientes (${data.length})` },
      ...nombres.map((nombre) => {
        const pendientes = data.filter(
          (row) => (row.nombramiento_firmantes || [])
            .some((f) => f.nombre === nombre && !f.firmado),
        ).length;
        return { value: nombre, label: `Pendientes de mi firma — ${nombre} (${pendientes})` };
      }),
    ];
  }, [data, activeTab, subTabFirma]);

  // Dataset de la tabla del tab Pendientes de Firma, aplicando el filtro por firmante
  const dataPendientesDeFirma = useMemo(() => {
    if (filtroFirmante === 'todos') return data;
    return data.filter(
      (row) => (row.nombramiento_firmantes || [])
        .some((f) => f.nombre === filtroFirmante && !f.firmado),
    );
  }, [data, filtroFirmante]);

  const handleFiltroFirmanteChange = (value) => {
    setFiltroFirmante(value);
    setSelectedRowKeys([]);
  };

  // Dataset base (antes del filtro por Tipo de Contratación) del tab activo:
  // Empleados usa dataEmpleados, Pendientes de Firma ya viene filtrado por firmante,
  // el resto de los tabs usa data (ya filtrado por estatus, ver useEffect de activeTab).
  const baseDatasetPorTab = useMemo(() => {
    if (activeTab === TAB_EMPLEADOS) return dataEmpleados;
    // Sub-tab "Pendientes Imprimir": ya están completos, el filtro por firmante
    // no aplica -- se usa "data" (ya filtrado a estado 8 por el useEffect de arriba).
    if (activeTab === TAB_PENDIENTE_FIRMA && subTabFirma === SUBTAB_FIRMA_PENDIENTES) return dataPendientesDeFirma;
    return data;
  }, [activeTab, data, dataEmpleados, dataPendientesDeFirma, subTabFirma]);

  // Opciones del filtro por Tipo de Contratación: solo los que de verdad aparecen
  // en el dataset del tab activo (dinámico, igual que opcionesFiltroFirmante).
  const opcionesFiltroTipoContratacion = useMemo(() => {
    const tipos = [];
    baseDatasetPorTab.forEach((row) => {
      if (row.tipo_de_contratacion_id != null
        && !tipos.some((t) => t.id === row.tipo_de_contratacion_id)) {
        tipos.push({
          id: row.tipo_de_contratacion_id,
          descripcion: row.tipo_de_contratacion_descripcion || 'Sin Tipo de Contratación',
        });
      }
    });
    return [
      { value: 'todos', label: `Todos los Tipos de Contratación (${baseDatasetPorTab.length})` },
      ...tipos.map((tipo) => {
        const total = baseDatasetPorTab.filter(
          (row) => row.tipo_de_contratacion_id === tipo.id,
        ).length;
        return { value: String(tipo.id), label: `${tipo.descripcion} (${total})` };
      }),
    ];
  }, [baseDatasetPorTab]);

  // Dataset final del tab activo, aplicando el filtro por Tipo de Contratación.
  const dataFiltradaPorTipoContratacion = useMemo(() => {
    if (filtroTipoContratacion === 'todos') return baseDatasetPorTab;
    return baseDatasetPorTab.filter(
      (row) => String(row.tipo_de_contratacion_id) === filtroTipoContratacion,
    );
  }, [baseDatasetPorTab, filtroTipoContratacion]);

  const handleFiltroTipoContratacionChange = (value) => {
    setFiltroTipoContratacion(value);
    setSelectedRowKeys([]);
  };

  // Selector de filtro por Tipo de Contratación, reutilizado en todos los tabs con tabla.
  const FiltroTipoContratacion = () => (
    <AntSelect
      value={filtroTipoContratacion}
      onChange={handleFiltroTipoContratacionChange}
      options={opcionesFiltroTipoContratacion}
      style={{ minWidth: 300 }}
    />
  );

  // ── Polling de operaciones en background (patrón CalculosDeNomina) ───────────
  // Consulta ProcesoEnCursoTerminado cada 2s.
  // Actualiza progresoActual (en_curso / total) en cada tick para mostrar avance.
  // Termina cuando procesando===false.
  useEffect(() => {
    if (!isPolling || !pollingSnapshot) return () => {};

    let intentos = 0;
    const maxIntentos = 340; // máx ~11 min

    pollingRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const { descripcionProceso, operacion } = pollingSnapshot;

        const lista = await getProcesoEnCursoTerminado({ descripcion: descripcionProceso });
        const proceso = lista[0];

        if (proceso) {
          // Actualizar contador visible en el modal
          setProgresoActual({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;

        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
          setIsPolling(false);
          setPollingSnapshot(null);
          setIsModalProgresoVisible(false);
          setProgresoActual({ en_curso: 0, total: 0 });

          notification.success({
            message: 'Operación completada',
            description: `La operación "${operacion}" finalizó correctamente.`,
            placement: 'topRight',
            duration: 6,
          });

          fetchData();
          setSelectedRowKeys([]);
          if (pollingOnCerrar) pollingOnCerrar();
          setPollingOnCerrar(null);
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling operación de nombramientos] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
  }, [isPolling, pollingSnapshot]); // eslint-disable-line react-hooks/exhaustive-deps

  // Clave de fila según tab: nombramientos usan nombramiento_id, empleados usan id
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getRowKey = (record) => (activeTab === TAB_EMPLEADOS ? record.id : record.nombramiento_id);

  // Fuente de datos activa según tab
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getActiveDataSource = () => (activeTab === TAB_EMPLEADOS ? dataEmpleados : data);

  // Payload de empleados a partir de las filas seleccionadas
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const buildEmpleadosPayload = () => getActiveDataSource()
    .filter((e) => selectedRowKeys.includes(getRowKey(e)))
    .map((e) => ({ id: e.id }));

  // const handleTableChange = (page, pageSize) => {
  //   const start = (page - 1) * pageSize;
  //   const end = start + pageSize;
  //   const paginated = filteredData.slice(start, end);

  //     setData({ count: filteredData.length, results: paginated });
  //     setPagination({ current: page, pageSize, total: filteredData.length });
  //  };
  const todosYaFirmadosPorUsuario = useMemo(() => {
    if (!currentUser?.id || selectedRowKeys.length === 0) return false;
    const seleccionados = getActiveDataSource()
      .filter((e) => selectedRowKeys.includes(getRowKey(e)));
    if (seleccionados.length === 0) return false;
    return seleccionados.every(
      (row) => (row.usuario_ids_que_firmaron || []).includes(currentUser.id),
    );
  }, [selectedRowKeys, currentUser, data, dataEmpleados]);

  const onClickBaja = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('Selecciona al menos un empleado para dar de baja');
      return;
    }

    // Obtener los registros seleccionados
    const empleadosSeleccionados = getActiveDataSource().filter((e) => selectedRowKeys.includes(getRowKey(e)));

    const estatusInvalidos = ['CANCELADO', 'BAJA'];

    // Verificar si alguno tiene estatus no permitido
    const empleadosConEstatusInvalidos = empleadosSeleccionados.filter((e) => estatusInvalidos.includes((e.estado_nombramiento || '').toUpperCase()));

    if (empleadosConEstatusInvalidos.length > 0) {
      message.error('No se puede dar de baja a empleados con nombramiento en estatus Cancelado, No Vigente o Baja.');
      return;
    }

    //  Todos válidos → abrir modal
    formBaja.resetFields();
    const motivoDefault = motivosBaja.find((m) => m.concepto === 'TERMINACIÓN DEL NOMBRAMIENTO');
    if (motivoDefault) {
      formBaja.setFieldsValue({ nombramiento_estado_nombramiento_id: motivoDefault.id });
    }
    setIsModalBajaVisible(true);
  };

  const onClickAutorizar = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('Selecciona al menos un empleado para autorizar nombramiento');
      return;
    }
    // Obtener los registros seleccionados
    const empleadosSeleccionados = getActiveDataSource().filter((e) => selectedRowKeys.includes(getRowKey(e)));

    const estatusInvalidos = ['CANCELADO', 'VIGENTE', 'BAJA'];

    // Verificar si alguno tiene estatus no permitido
    const empleadosConEstatusInvalidos = empleadosSeleccionados.filter((e) => estatusInvalidos.includes((e.estado_nombramiento || '').toUpperCase()));

    if (empleadosConEstatusInvalidos.length > 0) {
      message.error('No se puede Autorizar a empleados con nombramiento en estatus Cancelado, Vigente o Baja.');
      return;
    }

    setIsModalAutorizarVisible(true); //  abre el modal
  };

  const onClickFirmar = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('Selecciona al menos un nombramiento para firmar');
      return;
    }
    if (todosYaFirmadosPorUsuario) {
      message.warning('Ya firmaste todos los nombramientos seleccionados.');
      return;
    }
    if (!firmanteFEAInfo?.existeConfiguracion) {
      message.error(
        'No hay firmantes de Firma Electrónica (FEA) configurados. '
        + 'Configure al menos un firmante en Limitación de Autorización de Nombramientos.',
        6,
      );
      return;
    }
    if (!firmanteFEAInfo?.puedeFirmar) {
      message.error('No tienes autorización para firmar electrónicamente (FEA) Nombramientos.');
      return;
    }
    setArchivoCertificado(null);
    setArchivoKey(null);
    formFirmar.resetFields();
    setIsModalFirmarVisible(true);
  };

  const onClickImprimir = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('Selecciona al menos un nombramiento para marcar como impreso');
      return;
    }
    Modal.confirm({
      title: 'Marcar como Impreso',
      content: `¿Confirma que ya se imprimió y entregó ${selectedRowKeys.length === 1 ? 'este nombramiento' : `estos ${selectedRowKeys.length} nombramientos`}? Pasará(n) a Vigente(s).`,
      okText: 'Confirmar',
      cancelText: 'Cancelar',
      onOk: async () => {
        const resultado = await postImprimirNombramientoMasivo({ ids: [...selectedRowKeys] });
        if (!resultado) return;
        const totalImpresos = resultado.impresos?.length || 0;
        if (totalImpresos > 0) {
          notification.success({
            message: 'Marcado como impreso',
            description: `${totalImpresos} nombramiento(s) pasaron a Vigente.`,
            placement: 'topRight',
          });
        }
        preserveSelectionRef.current = false;
        fetchData();
      },
    });
  };

  const onClickDescargarEvidencia = async () => {
    if (selectedRowKeys.length !== 1) {
      message.warning('Selecciona un solo nombramiento para descargar su evidencia de firma');
      return;
    }
    const [key] = selectedRowKeys;
    setLoading(true);
    try {
      const nombramiento = await getNombramiento(key);
      if (nombramiento?.documento_firmado_evidencia) {
        // Evidencia adjuntada manualmente (ver "Adjuntar Evidencia"): archivo propio.
        window.open(nombramiento.documento_firmado_evidencia, '_blank', 'noopener,noreferrer');
      } else if (nombramiento?.fea_validation_url) {
        // Firmado por FEA: se abre el portal oficial de validación/descarga del documento.
        window.open(nombramiento.fea_validation_url, '_blank', 'noopener,noreferrer');
      } else {
        message.warning('Este nombramiento no tiene evidencia de firma disponible para descargar.');
      }
    } finally {
      setLoading(false);
    }
  };

  const onClickAdjuntarEvidencia = () => {
    if (selectedRowKeys.length !== 1) {
      message.warning('Selecciona un solo nombramiento para adjuntar su evidencia de firma');
      return;
    }
    setArchivoEvidencia(null);
    setIsModalEvidenciaVisible(true);
  };

  const handleAdjuntarEvidenciaSubmit = async () => {
    if (!archivoEvidencia) {
      message.error('Selecciona el PDF de evidencia de firma');
      return;
    }
    const [key] = selectedRowKeys;
    const registro = getActiveDataSource().find((e) => getRowKey(e) === key);
    const nombramientoId = registro?.nombramiento_id || key;

    setLoadingEvidencia(true);
    try {
      const resultado = await patchNombramientoDocumentoEvidencia(nombramientoId, archivoEvidencia);
      if (!resultado) return;
      setIsModalEvidenciaVisible(false);
      setArchivoEvidencia(null);
      fetchData();
    } finally {
      setLoadingEvidencia(false);
    }
  };

  const onClickVistoBueno = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('Selecciona al menos un nombramiento para dar visto bueno');
      return;
    }
    setVisibleAlertVistoBueno(true);
  };

  const onClickConsultarFEA = async () => {
    if (selectedRowKeys.length !== 1) {
      message.warning('Selecciona un solo nombramiento para consultar su estado en FEA');
      return;
    }
    const [key] = selectedRowKeys;
    const registro = getActiveDataSource().find((e) => getRowKey(e) === key);
    const nombramientoId = registro?.nombramiento_id || key;

    setLoadingConsultaFEA(true);
    setConsultaFEAData(null);
    setIsModalConsultaFEAVisible(true);
    try {
      const resultado = await getConsultarFirmaNombramientoFea(nombramientoId);
      setConsultaFEAData(resultado);
    } finally {
      setLoadingConsultaFEA(false);
    }
  };

  const onClickSubirPdfFEA = () => {
    if (selectedRowKeys.length !== 1) {
      message.warning('Selecciona un solo nombramiento para subir su PDF a FEA');
      return;
    }
    setArchivoPdfFEA(null);
    setIsModalSubirPdfFEAVisible(true);
  };

  const handleSubirPdfFEASubmit = async () => {
    if (!archivoPdfFEA) {
      message.error('Selecciona el archivo PDF a subir');
      return;
    }
    const [key] = selectedRowKeys;
    const registro = getActiveDataSource().find((e) => getRowKey(e) === key);
    const nombramientoId = registro?.nombramiento_id || key;

    setLoadingSubirPdfFEA(true);
    try {
      const resultado = await postSubirPdfNombramientoFea(nombramientoId, archivoPdfFEA);
      if (resultado) {
        message.success('PDF subido correctamente al servicio FEA');
        setIsModalSubirPdfFEAVisible(false);
        setArchivoPdfFEA(null);
      }
    } finally {
      setLoadingSubirPdfFEA(false);
    }
  };

  // Cierra y limpia el modal de Firmar (FEA): reutilizado al cancelar y al
  // terminar de firmar con éxito, para no dejar certificado/contraseña de un
  // intento pegados al siguiente.
  const cerrarModalFirmar = () => {
    setIsModalFirmarVisible(false);
    formFirmar.resetFields();
    formFirmar.setFieldsValue({ contrasena: undefined });
    setArchivoCertificado(null);
    setArchivoKey(null);
  };

  const handleFirmarSubmit = async () => {
    try {
      const ids = getActiveDataSource()
        .filter((e) => selectedRowKeys.includes(getRowKey(e)))
        .map((e) => e.nombramiento_id);

      let payload = { ids };

      // El paso del usuario puede ser de confirmación simple (sin certificado FEA,
      // ver firmanteFEA.js/firmar_nombramiento_masivo) -- en ese caso el modal no pide
      // certificado ni contraseña, solo se confirma.
      if (firmanteFEAInfo?.requiereFea) {
        const values = await formFirmar.validateFields();
        if (!archivoCertificado) {
          message.error('Adjunta el archivo de certificado (.p12 o .cer)');
          return;
        }
        const esP12 = archivoCertificado.name.toLowerCase().endsWith('.p12');
        if (!esP12 && !archivoKey) {
          message.error('Al usar .cer debes adjuntar también el archivo de llave privada (.key)');
          return;
        }

        const leerBase64 = (file) => new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result.split(',')[1]);
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });

        const fileBase64 = await leerBase64(archivoCertificado);

        payload = { ids, contrasena: values.contrasena };
        if (esP12) {
          payload.pkcs12b64 = fileBase64;
        } else {
          payload.cer_b64 = fileBase64;
          payload.key_b64 = await leerBase64(archivoKey);
        }
      }

      setLoadingFirmar(true);

      const resultado = await postFirmarNombramientoMasivo(payload);
      if (!resultado) {
        // postFirmarNombramientoMasivo ya mostró el detalle del error vía onError()
        return;
      }

      const totalFirmados = resultado.firmados?.length || 0;
      const totalErrores = resultado.errores?.length || 0;
      const totalOmitidos = resultado.omitidos?.length || 0;

      if (totalFirmados > 0) {
        notification.success({
          message: 'Firma completada',
          description: totalErrores > 0
            ? `${totalFirmados} de ${ids.length} nombramiento(s) firmado(s) correctamente. ${totalErrores} no se pudieron firmar.`
            : `${totalFirmados} nombramiento(s) firmado(s) correctamente.`,
          placement: 'topRight',
        });
      }
      if (totalErrores > 0) {
        const motivos = [...new Set(resultado.errores.map((e) => e.error))].join(' | ');
        message.warning(`${totalErrores} nombramiento(s) no se pudieron firmar: ${motivos}`, 8);
      }
      if (totalOmitidos > 0) {
        // No es un error: el usuario ya había firmado estos nombramientos antes,
        // simplemente se omiten del lote en vez de bloquear a los demás.
        message.info(`${totalOmitidos} nombramiento(s) ya estaban firmados por ti y se omitieron.`, 6);
      }

      if (totalFirmados > 0 || (totalOmitidos > 0 && totalErrores === 0)) {
        // Firma exitosa (total o parcial), o el lote completo ya estaba firmado:
        // cerrar el modal, ya se informó el detalle arriba.
        cerrarModalFirmar();
      }

      preserveSelectionRef.current = true;
      fetchData();
    } catch (err) {
      const detail = err?.response?.data?.detail || err?.message || 'Error al firmar';
      message.error(detail);
    } finally {
      setLoadingFirmar(false);
    }
  };

  const handleValidarVigencia = () => {
    setIsModalProgresoVisible(true);

    API.post('estructura-organizacional/validar-vigencia-nombramientos/')
      .then(() => {
        // Espera fija antes del primer poll para que el task finalice
        setTimeout(() => {
          getNombramientosvistaoptimized()
            .then((nuevosDatos) => {
              setIsModalProgresoVisible(false);
              message.success('Verificación de términos de vigencia completada.');
              const filtrados = nuevosDatos.filter(
                (e) => (e.plaza_id !== null && e.plaza !== null)
                  || e.nombramiento_estado_nombramiento_id === 4,
              );
              setData(filtrados);
              setOriginalData(filtrados);
            })
            .catch(() => {
              setIsModalProgresoVisible(false);
              fetchData();
            });
        }, 3000);
      })
      .catch(() => {
        message.error('Error al iniciar la verificación.');
        setIsModalProgresoVisible(false);
      });
  };

  const onCancelWithFetch = () => {
    fetchData(1, null);
    setSelectedRowKeys([]);
    setCurrentTabKey('general');
    setCurrentTabKeyDO('adscripcion');
    setCurrentParentTabKey('general');
    setData([]);
    setVisible(false);
  };

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
    formOperacionales.resetFields();
    formDireccion.resetFields();
    formPlazas.resetFields();
    setCurrentTabKey('general');
    setCurrentTabKeyDO('adscripcion');
    setCurrentParentTabKey('general');
    setNominaDisplay();
    setIsBlocked(false);
  };

  // `recordDobleClick` llega cuando se invoca por doble clic sobre una fila
  // (Table.jsx: onDoubleClick -> controls.onClickEdit(record)). En ese caso se usa
  // ESE registro directamente -- nunca selectedRowKeys -- porque el clic simple que
  // siempre precede al doble clic ya disparó handleOnRowClick(record), que puede dejar
  // más de una fila en selectedRowKeys (acumula en vez de reemplazar) si ya había una
  // selección previa de otro empleado/nombramiento. Leer `selectedRowKeys[0]` en ese
  // caso puede resolver al registro equivocado (bug real: doble clic en el Nombramiento
  // folio 158 de un empleado con 2 Nombramientos abría el folio 159 del mismo empleado,
  // porque selectedRowKeys ya traía [159, 158] y se tomaba el primero).
  const onClickEdit = async (recordDobleClick) => {
    try {
      let empleado = recordDobleClick;

      if (!empleado) {
        if (selectedRowKeys.length === 0) {
          message.warning('Selecciona un empleado para editar.');
          return;
        }
        if (selectedRowKeys.length > 1) {
          message.warning('Selecciona solo un empleado para editar.');
          return;
        }

        const [key] = selectedRowKeys;
        empleado = getActiveDataSource().find((e) => getRowKey(e) === key);
      }

      if (!empleado) {
        message.error('No se encontró información del empleado seleccionado.');
        return;
      }

      setLoading(true);

      // Limpiar formularios
      form.resetFields();
      formOperacionales.resetFields();
      formDireccion.resetFields();
      formPlazas.resetFields();

      // Calcular edad
      const edad = (() => {
        if (!empleado.fecha_de_nacimiento) return '';
        const nacimiento = new Date(empleado.fecha_de_nacimiento);
        const hoy = new Date();
        const age = hoy.getFullYear() - nacimiento.getFullYear();
        const mes = hoy.getMonth() - nacimiento.getMonth();
        return mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate()) ? age - 1 : age;
      })();

      // Preparar datos para el formulario principal
      form.setFieldsValue({
        ...empleado,
        edad,
        estado_civil: empleado.estado_civil,
        nacionalidad: empleado.nacionalidad,
        genero: empleado.genero,
        entidad: empleado.lugar_nacimiento_estado,
        caracter_nombramiento: empleado.caracter_de_nombramiento_id,
        termino_vigencia: empleado.nombramiento_termino_de_vigencia ? moment(empleado.nombramiento_termino_de_vigencia) : null,
        inicio_vigencia: empleado.nombramiento_inicio_vigencia ? moment(empleado.nombramiento_inicio_vigencia) : null,
        fecha_emision: empleado.nombramiento_fecha_de_emision ? moment(empleado.nombramiento_fecha_de_emision) : null,
        estado_nombramiento: empleado.nombramiento_estado_nombramiento,
        nombramiento_folio: empleado.nombramiento_folio,
        nombramiento_id: empleado.nombramiento_id || null,
        prestaciones: empleado.prestaciones_para_nombramiento_descripcion || '',
        plaza: empleado.plaza,
        puesto: empleado.puesto,
        tipo_empleado: empleado.tipo_de_empleado,
        jornada: empleado.jornada,
        categoria_de_empleado: empleado.categoria_de_empleado,
        tipo_de_contratacion: empleado.tipo_de_contratacion_descripcion || '-',
      });

      formDireccion.setFieldsValue({
        ...empleado,
        estado: empleado.lugar_nacimiento_estado,
        municipio: empleado.lugar_nacimiento_localidad,
        codigo_postal: empleado.codigo_postal,
      });

      formOperacionales.setFieldsValue({
        sueldo_mensual: empleado.sueldo_mensual,
      });

      formPlazas.setFieldsValue({
        plaza: empleado.plaza,
        puesto: empleado.puesto,
      });

      // Activar vista de edición
      setVisible(true);
    } catch (error) {
      onError(error);
    } finally {
      setLoading(false);
    }
  };

  // Guarda Carácter de Nombramiento / Inicio y Término de Vigencia desde la pantalla
  // "Editar Empleado" > Datos Generales — único subconjunto de campos ahí habilitado
  // para usuarios con permiso editar_nombramiento (el resto son datos de solo lectura
  // derivados de la Plaza/Empleado, no editables desde aquí).
  const onFinishEditarNombramiento = async () => {
    const nombramientoId = form.getFieldValue('nombramiento_id');
    if (!nombramientoId) {
      message.warning('Este empleado no tiene un Nombramiento existente para editar.');
      return;
    }
    try {
      await form.validateFields(['caracter_nombramiento', 'inicio_vigencia', 'termino_vigencia']);
    } catch (error) {
      return;
    }
    const values = form.getFieldsValue();
    const payload = {
      caracter_de_nombramiento: values.caracter_nombramiento,
      inicio_vigencia: values.inicio_vigencia ? values.inicio_vigencia.format('YYYY-MM-DD') : null,
      termino_de_vigencia: values.termino_vigencia ? values.termino_vigencia.format('YYYY-MM-DD') : null,
    };
    setLoading(true);
    const resultado = await patchNombramiento(nombramientoId, payload);
    setLoading(false);
    if (resultado) {
      onCancelWithFetch();
    }
  };

  const onBuscar = async (customFilters = null) => {
    try {
      setLoading(true);
      const filtros = customFilters || form.getFieldsValue();
      setCurrentFilters({ ...filtros });

      let empleadosFiltrados = [...data]; // Usamos `data` como base para todo

      if (filtros.numeroEmpleado) {
        empleadosFiltrados = empleadosFiltrados.filter((e) => String(e.numero_de_empleado).includes(String(filtros.numeroEmpleado).trim()));
      }

      if (filtros.nombreCompleto) {
        const nombre = filtros.nombreCompleto.toLowerCase().trim();
        empleadosFiltrados = empleadosFiltrados.filter((e) => (`${e.nombre || ''} ${e.apellido_paterno || ''} ${e.apellido_materno || ''}`)
          .toLowerCase()
          .includes(nombre));
      }

      if (filtros.folio) {
        empleadosFiltrados = empleadosFiltrados.filter((e) => (e.nombramiento_folio || '').toLowerCase().includes(filtros.folio.toLowerCase()));
      }

      if (filtros.fechaEmision) {
        const fecha = filtros.fechaEmision.format('YYYY-MM-DD');
        empleadosFiltrados = empleadosFiltrados.filter((e) => e.nombramiento_fecha_de_emision?.startsWith(fecha));
      }

      if (filtros.vigenciaInicio) {
        const fecha = filtros.vigenciaInicio.format('YYYY-MM-DD');
        empleadosFiltrados = empleadosFiltrados.filter((e) => e.nombramiento_inicio_vigencia?.startsWith(fecha));
      }

      if (filtros.vigenciaFin) {
        const fecha = filtros.vigenciaFin.format('YYYY-MM-DD');
        empleadosFiltrados = empleadosFiltrados.filter((e) => e.nombramiento_termino_de_vigencia?.startsWith(fecha));
      }

      if (filtros.plaza) {
        empleadosFiltrados = empleadosFiltrados.filter((e) => String(e.plaza_id) === String(filtros.plaza));
      }

      if (filtros.directorio_area) {
        empleadosFiltrados = empleadosFiltrados.filter((e) => (e.directorio_area || '').trim().toLowerCase() === filtros.directorio_area.trim().toLowerCase());
      }

      if (filtros.puesto) {
        empleadosFiltrados = empleadosFiltrados.filter((e) => String(e.puesto_id) === String(filtros.puesto));
      }

      if (filtros.categoria_de_empleado) {
        empleadosFiltrados = empleadosFiltrados.filter((e) => String(e.categoria_de_empleado_id) === String(filtros.categoria_de_empleado));
      }

      if (filtros.estatus) {
        empleadosFiltrados = empleadosFiltrados.filter((e) => String(e.estado_del_empleado).toLowerCase() === filtros.estatus.toLowerCase());
      }

      if (empleadosFiltrados.length === 0) {
        message.warning('No se encontraron resultados con los filtros ingresados.');
      }

      setData(empleadosFiltrados); // Usamos un solo estado: data
      setSelectedRowKeys([]);
    } catch (err) {
      onError(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (refrescandoConFiltro && currentFilters && data.length) {
      onBuscar(currentFilters);
      setRefrescandoConFiltro(false); // solo se dispara una vez
    }
  }, [data]);

  const refrescarDatosConFiltro = async () => {
    const nuevosDatos = await getNombramientosvistaoptimized();

    // Actualiza los datos (esto se reflejará en el <Table />)
    setData(nuevosDatos);
    setOriginalData(nuevosDatos);

    // Aplica los filtros actuales, pero con delay mínimo para asegurar que setData ya se aplicó
    if (currentFilters) {
      setTimeout(() => {
        onBuscar(currentFilters);
      }, 50); // delay pequeño
    }
  };
  // ── Helper para operaciones asíncronas con polling via useEffect ─────────────
  // POST (fire & forget) → backend pone procesando=True → useEffect hace poll a
  // ProcesoEnCursoTerminado hasta que procesando===false (task terminó).
  const ejecutarOperacionAsync = useCallback((
    url,
    payload,
    {
      onCerrar, operacion = 'nombramiento', descripcionProceso = 'nombramiento', rawBody = false,
    } = {},
  ) => {
    setProgresoActual({ en_curso: 0, total: 0 });
    setIsModalProgresoVisible(true);

    // rawBody=true: el payload ya tiene la forma final del body (no se envuelve en {items:})
    API.post(url, rawBody ? payload : { items: payload })
      .then(() => {
        setPollingSnapshot({ descripcionProceso, operacion });
        if (onCerrar) setPollingOnCerrar(() => onCerrar);
        setIsPolling(true);
      })
      .catch((err) => {
        const detalle = err?.response?.data?.detail
          || err?.response?.data?.message
          || (typeof err?.response?.data === 'string' ? err.response.data : null)
          || err?.message
          || 'Error al iniciar la operación.';
        message.error(detalle, 8);
        setIsModalProgresoVisible(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const generarPeriodos = (inicioVigencia, terminoVigencia, periodicidad) => {
    if (!inicioVigencia || !terminoVigencia || !periodicidad) return [];
    const inicio = dayjs(inicioVigencia);
    const fin = dayjs(terminoVigencia);
    if (!inicio.isValid() || !fin.isValid() || fin.isBefore(inicio)) return [];

    const resultado = [];
    let current = inicio;
    let idx = 0;

    while (current.isBefore(fin) || current.isSame(fin, 'day')) {
      let periodoFin;
      let siguiente;
      if (periodicidad === 'quincenal') {
        // Quincenas naturales: 1-15 y 16-último día del mes
        if (current.date() <= 15) {
          const quincenaFin = current.date(15);
          periodoFin = quincenaFin.isAfter(fin) ? fin : quincenaFin;
          siguiente = current.date(16);
        } else {
          const quincenaFin = current.endOf('month').startOf('day');
          periodoFin = quincenaFin.isAfter(fin) ? fin : quincenaFin;
          siguiente = current.add(1, 'month').date(1);
        }
      } else {
        const meses = PERIODICIDAD_MESES[periodicidad];
        const candidato = current.add(meses, 'month').subtract(1, 'day');
        periodoFin = candidato.isAfter(fin) ? fin : candidato;
        siguiente = current.add(meses, 'month');
      }
      resultado.push({
        key: idx,
        inicio: current.format('YYYY-MM-DD'),
        fin: periodoFin.format('YYYY-MM-DD'),
      });
      idx += 1;
      current = siguiente;
    }
    return resultado;
  };

  const onNombramientoFieldChange = () => {
    const values = formNombramiento.getFieldsValue();
    if (values.inicio_vigencia && values.termino_vigencia && values.periodicidad) {
      const generados = generarPeriodos(
        values.inicio_vigencia.format('YYYY-MM-DD'),
        values.termino_vigencia.format('YYYY-MM-DD'),
        values.periodicidad,
      );
      setPeriodosNombramiento(generados);
    } else {
      setPeriodosNombramiento([]);
    }
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await formNombramiento.validateFields();

      if (!selectedRowKeys.length) {
        message.warning('Selecciona al menos un empleado.');
        return;
      }

      const values = formNombramiento.getFieldsValue();

      if (!values.caracter_de_nombramiento || !values.inicio_vigencia || !values.termino_vigencia) {
        message.error('Completa todos los campos requeridos.');
        return;
      }

      const caracterDeNombramientoId = values.caracter_de_nombramiento;
      const inicioVigencia = values.inicio_vigencia.format('YYYY-MM-DD');
      const terminoVigencia = values.termino_vigencia.format('YYYY-MM-DD');
      const empleadosPayload = buildEmpleadosPayload();

      // Si hay periodicidad, enviar la lista de períodos en el body
      const periodos = values.periodicidad && periodosNombramiento.length
        ? periodosNombramiento.map((p) => ({ inicio: p.inicio, fin: p.fin }))
        : null;

      const periodicidadLabel = values.periodicidad
        ? (PERIODICIDAD_OPCIONES.find((o) => o.value === values.periodicidad)?.label ?? values.periodicidad)
        : null;

      // Siempre enviar como objeto {items, periodos, periodicidad, tipo_de_movimiento}
      const payload = {
        items: empleadosPayload,
        periodos,
        periodicidad: periodicidadLabel,
        tipo_de_movimiento: values.tipo_de_movimiento || null,
      };

      ejecutarOperacionAsync(
        `estructura-organizacional/agregar-nombramiento/${caracterDeNombramientoId}/${inicioVigencia}/${terminoVigencia}/`,
        payload,
        {
          operacion: 'Agregar Nombramiento',
          descripcionProceso: 'Agregar Nombramiento',
          rawBody: true,
          onCerrar: () => {
            setIsModalNombramientoMasivoVisible(false);
            formNombramiento.resetFields();
            setPeriodosNombramiento([]);
          },
        },
      );
    } catch (error) {
      message.error('Error al guardar los nombramientos.');
    } finally {
      setLoading(false);
    }
  };

  const onBajaFinish = async () => {
    try {
      setLoading(true);
      await formBaja.validateFields();

      const values = formBaja.getFieldsValue();
      const fecha = values.nombramiento_fecha_baja?.format('YYYY-MM-DD');
      const motivoId = values.nombramiento_estado_nombramiento_id;

      // Manejo de los nuevos campos de liquidación
      const aplicaLiquidacion = values.aplica_finiquito ? 'True' : 'False';
      const liquidacionId = values.aplica_finiquito ? values.tipo_finiquito : 0; // Mandamos 0 si no aplica

      if (!fecha || !motivoId) {
        message.error('Faltan datos requeridos para procesar la baja.');
        return;
      }

      const empleadosPayload = getActiveDataSource()
        .filter((e) => selectedRowKeys.includes(getRowKey(e)))
        .map((e) => ({ id: e.id, nombramiento_id: e.nombramiento_id || null }));

      // estadoDestinoId:
      //   4 (BAJA)          → desde tab Vigentes → aparece en tab Baja
      //   3 (NO VIGENTE)    → desde tab No Vigentes (Pendientes) → aparece en tab No Vigentes
      const estadoDestinoId = activeTab === TAB_NO_VIGENTES_PENDIENTES ? 3 : 4;

      ejecutarOperacionAsync(
        `estructura-organizacional/baja-nombramiento/${motivoId}/${fecha}/${aplicaLiquidacion}/${liquidacionId}/${estadoDestinoId}/`,
        empleadosPayload,
        {
          operacion: 'Baja de Nombramiento',
          descripcionProceso: 'Baja Nombramiento',
          onCerrar: () => {
            setIsModalBajaVisible(false);
            formBaja.resetFields();
          },
        },
      );
    } catch (error) {
      message.error('Error al dar de baja los nombramientos.');
    } finally {
      setLoading(false);
    }
  };

  const onAutorizarFinish = async () => {
    try {
      setLoading(true);

      // 1. Validar campos del formulario
      await formAutorizar.validateFields();

      if (!selectedRowKeys.length) {
        message.warning('Selecciona al menos un empleado.');
        return;
      }

      const values = formAutorizar.getFieldsValue();

      // 2. Formatear datos para la URL
      const fechaEmision = values.fecha_emision.format('YYYY-MM-DD');
      const horaEmision = values.hora_emision.format('HH:mm:ss');
      const lugarEmision = encodeURIComponent((values.lugar_emision || '').trim());

      // 3. Resolver ID de empleado + nombramiento específico desde la fuente de datos activa
      const empleadosPayload = getActiveDataSource()
        .filter((e) => selectedRowKeys.includes(getRowKey(e)))
        .map((e) => ({
          id: e.id,
          nombramiento_id: e.nombramiento_id || null,
          observaciones: values.observaciones || '',
        }));

      // 4. ¡CORRECCIÓN!: Ruta apuntando a estructura-organizacional
      const url = `estructura-organizacional/autorizar-nombramiento/${fechaEmision}/${horaEmision}/${lugarEmision}/`;

      // 5. Petición al backend (async con WebSocket)
      ejecutarOperacionAsync(url, empleadosPayload, {
        operacion: 'Autorizar Nombramiento',
        descripcionProceso: 'Autorizar Nombramiento',
        onCerrar: () => {
          setIsModalAutorizarVisible(false);
          formAutorizar.resetFields();
        },
      });
    } catch (error) {
      // onError (utils/handlers.js) normaliza cualquier forma de error del
      // backend (string, array, objeto tipo {non_field_errors: [...]}) a
      // texto legible -- pasar error.response.data.message/detail directo a
      // message.error() truena con "Objects are not valid as a React child"
      // cuando el backend responde con un objeto en vez de un string (mismo
      // bug confirmado en AutorizarContratación.jsx).
      onError(error, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const onClickPreview = async () => {
    // El tab Vigentes (único que usa este botón) tiene rowKey="nombramiento_id",
    // así que selectedRowKeys ya son IDs de nombramiento, no de empleado.
    const idsNombramientos = selectedRowKeys
      .filter((nombramientoId) => data.some((e) => e.nombramiento_id === nombramientoId));

    if (idsNombramientos.length === 0) {
      message.warning('No se encontraron nombramientos para los empleados seleccionados.');
      return;
    }

    setLoading(true);
    try {
      // Obtener el formato de nombramiento activo (estados_globales = 1)
      const formatos = await getConfiguradorNombramientosFormato({ estados_globales: 1 });
      const formatoActivo = Array.isArray(formatos)
        ? formatos[0]
        : formatos?.results?.[0];

      if (!formatoActivo?.no_de_reporte) {
        message.warning('No se encontró un Formato de Nombramiento activo. Configúralo en Configurador de Nombramientos → Formato.');
        return;
      }

      const reporteId = parseInt(formatoActivo.no_de_reporte, 10);

      if (Number.isNaN(reporteId)) {
        message.warning('El número de reporte del Formato de Nombramiento no es válido.');
        return;
      }

      const values = {
        ID: reporteId,
        Parametros: [
          {
            Nombre: 'nombramientos_por_folio',
            TipoParametro: 'EnteroLista',
            Valores: idsNombramientos.map((id) => ({ Value: id })),
          },
        ],
      };

      const file = await postObtenerReporte(values);

      if (file) {
        setBase64(file);
        setVisiblePreview(true);
      } else {
        message.error('Error al generar el reporte. Inténtalo de nuevo más tarde.');
      }
    } finally {
      setLoading(false);
    }
  };

  const onRenovarFinish = async () => {
    try {
      setLoading(true);

      // Validar el formulario antes de continuar
      await formRenovar.validateFields();

      // Obtener valores del formulario
      const values = formRenovar.getFieldsValue();

      // Verificación temprana de campos requeridos (redundante, pero útil para robustez)
      if (
        !values.inicio_vigencia
        || !values.termino_vigencia
        || !values.fecha_emision
        || !values.hora_emision
        || !values.lugar_emision
      ) {
        message.error('Todos los campos son obligatorios.');
        return;
      }

      // Filtrar los empleados seleccionados a partir de `data`, no `filteredData`
      const empleadosSeleccionados = getActiveDataSource().filter((e) => selectedRowKeys.includes(getRowKey(e)));

      // Validar que todos tengan estado "VIGENTE"
      const noVigentes = empleadosSeleccionados.filter(
        (e) => (e.nombramiento_estado_nombramiento || '').toUpperCase() !== 'VIGENTE',
      );

      if (noVigentes.length > 0) {
        message.warning(
          'Solo puedes renovar empleados con nombramiento en estado VIGENTE.',
        );
        return;
      }

      // Construir payload con nombramiento_id de los seleccionados
      const empleadosPayload = getActiveDataSource()
        .filter((e) => selectedRowKeys.includes(e.nombramiento_id))
        .map((e) => ({ nombramiento_id: e.nombramiento_id }));

      // Formatear los datos para la URL
      const inicioVigencia = values.inicio_vigencia.format('YYYY-MM-DD');
      const terminoVigencia = values.termino_vigencia.format('YYYY-MM-DD');
      const fechaEmision = values.fecha_emision.format('YYYY-MM-DD');
      const horaEmision = values.hora_emision.format('HH:mm:ss');
      const lugarEmision = encodeURIComponent((values.lugar_emision || '').trim());

      const url = `estructura-organizacional/renovar-nombramiento/${inicioVigencia}/${terminoVigencia}/${fechaEmision}/${horaEmision}/${lugarEmision}/`;

      ejecutarOperacionAsync(url, empleadosPayload, {
        operacion: 'Renovar Nombramiento',
        onCerrar: () => {
          setIsModalRenovarVisible(false);
          formRenovar.resetFields();
        },
      });
    } catch (error) {
      message.error('Error al renovar los nombramientos.');
    } finally {
      setLoading(false);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        // Eliminar empleado
        const deleted = await deleteEmpleado(key);
        if (deleted) {
          // Eliminar datos operacionales
          const datoOpEmp = await getDatoOperacionalesDeEmpleados({ empleado: key });
          if (datoOpEmp.length > 0) {
            await deleteDatoOperacionalDelEmpleado(datoOpEmp[0].id);
          }
          setVisibleAlert(false);
          onCancel();
          await refrescarDatosConFiltro();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    const rk = getRowKey(record);
    const alreadySelected = selectedRowKeys.includes(rk);
    const updatedKeys = alreadySelected
      ? selectedRowKeys.filter((k) => k !== rk)
      : [...selectedRowKeys, rk];

    setSelectedRowKeys(updatedKeys);

    // Mostrar en pantalla el tipo de nómina
    setNominaDisplay(record.tipo_nomina_empleado || '');

    // Bloquear si el registro está marcado como no habilitado (asumimos campo booleano)
    // Si no hay un campo `habilitado`, puedes ajustar esta lógica según convenga
    setIsBlocked(record.habilitado === false);

    // Preparar valores para el formulario
    const recordClonado = {
      ...record,
      tipo_de_contratacion: record.tipo_de_contratacion_descripcion || '-',
      fecha_emision: record.fecha_emision ? moment(record.fecha_emision) : null,
      inicio_vigencia: record.inicio_vigencia ? moment(record.inicio_vigencia) : null,
      termino_vigencia: record.termino_vigencia ? moment(record.termino_vigencia) : null,
    };

    form.setFieldsValue(recordClonado);
  };

  const handleSelectAll = (selected) => {
    if (selected) {
      // El tab Empleados tiene su propio estado de datos (dataEmpleados)
      const baseData = activeTab === TAB_EMPLEADOS ? dataEmpleados : data;
      const source = currentTableData.length ? currentTableData : baseData;
      const allKeys = source.map((row) => getRowKey(row));
      setSelectedRowKeys([...new Set(allKeys)]);
    } else {
      setSelectedRowKeys([]);
    }
  };

  const handleTableChange = (_pagination, _filters, _sorter, extra) => {
    // Ant Design provee currentDataSource con todos los registros filtrados (todas las páginas)
    if (extra?.currentDataSource) {
      setCurrentTableData(extra.currentDataSource);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'checkbox', // permite seleccionar varios empleados
    onSelect: (record, selected) => {
      const rk = getRowKey(record);
      if (selected) {
        setSelectedRowKeys([...selectedRowKeys, rk]);
      } else {
        setSelectedRowKeys(selectedRowKeys.filter((k) => k !== rk));
      }
    },
    onSelectAll: handleSelectAll,
  };
  const onClickAdd = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('Selecciona al menos un empleado antes de agregar nombramiento');
      return;
    }

    setIsModalNombramientoMasivoVisible(true); // muestra modal
  };

  const onClickRenovar = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('Selecciona al menos un nombramiento para renovar');
      return;
    }
    formRenovar.resetFields();
    setIsModalRenovarVisible(true);
  };
  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const deleteNombramientoItem = async () => {
    try {
      setLoading(true);
      if (!selectedRowKeys.length) return;
      await Promise.all(selectedRowKeys.map((id) => deleteNombramiento(id)));
      setVisibleAlertNombramiento(false);
      setSelectedRowKeys([]);
      await refrescarDatosConFiltro();
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const onClickDeleteNombramiento = () => {
    if (!selectedRowKeys.length) {
      message.warning('Selecciona al menos un nombramiento para eliminar');
      return;
    }
    setVisibleAlertNombramiento(true);
  };

  const handleVistoBuenoConfirm = async () => {
    try {
      setLoading(true);
      const activeSource = getActiveDataSource();
      const ids = activeSource
        .filter((e) => selectedRowKeys.includes(getRowKey(e)))
        .map((e) => e.nombramiento_id);
      const ok = await postDarVistoBuenoMasivo(ids);
      if (ok) {
        setVisibleAlertVistoBueno(false);
        setSelectedRowKeys([]);
        await refrescarDatosConFiltro();
      }
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  // Columna "Firmantes": estado de firma (FEA) por cada firmante requerido,
  // armada a partir de nombramiento_firmantes (ver _anexar_firmantes_fea en el backend).
  // Se agrega a todas las tablas de este consultor porque el dato ya viene en
  // cada fila de getNombramientosvistaoptimized, sin importar el tab activo.
  const columnaFirmantes = {
    titleText: 'Firmantes',
    key: 'nombramiento_firmantes',
    dataIndex: 'nombramiento_firmantes',
    width: 220,
    render: (firmantes) => {
      if (!firmantes || !firmantes.length) return '-';
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {firmantes.map((f) => (
            <Tag
              key={f.nombre}
              icon={f.firmado ? <CheckCircleOutlined /> : <ClockCircleOutlined />}
              color={f.firmado ? 'success' : 'warning'}
              style={{ width: 'fit-content' }}
            >
              {f.nombre}
            </Tag>
          ))}
        </div>
      );
    },
  };

  const columns = [
    {
      titleText: 'Folio',
      key: 'nombramiento_folio',
      dataIndex: 'nombramiento_folio',
      width: 70,
      render: (val) => val || '-',
    },
    {
      titleText: 'Fecha de Creación',
      dataIndex: 'nombramiento_fecha_de_creacion',
      key: 'nombramiento_fecha_de_creacion',
      width: 130,
      render: (val) => (val ? dayjs(val).format('YYYY-MM-DD') : '-'),
    },
    {
      titleText: 'Empleado',
      dataIndex: 'numero_y_nombre_completo',
      key: 'numero_y_nombre_completo',
      width: 250,
    },
    columnaFirmantes,
    {
      titleText: 'Plaza',
      key: 'plaza_clave',
      dataIndex: 'plaza_clave',
      width: 100,
    },
    {
      titleText: 'Puesto',
      key: 'puesto',
      dataIndex: 'puesto',
      width: 200,
    },
    {
      titleText: 'Área',
      key: 'directorio_area',
      dataIndex: 'directorio_area',
      width: 250,
    },
    {
      titleText: 'Categoría de Empleado',
      key: 'categoria_de_empleado',
      dataIndex: 'categoria_de_empleado',
      width: 200,
    },
    {
      titleText: 'Tipo de Contratación',
      key: 'tipo_de_contratacion_descripcion',
      dataIndex: 'tipo_de_contratacion_descripcion',
      width: 200,
      render: (val) => val || '-',
    },
    {
      titleText: 'Caracter de Nombramiento',
      key: 'caracter_de_nombramiento',
      dataIndex: 'caracter_de_nombramiento',
      width: 210,

    },
    {
      titleText: 'Inicio de Vigencia',
      key: 'nombramiento_inicio_vigencia',
      dataIndex: 'nombramiento_inicio_vigencia',
      width: 150,
    },
    {
      titleText: 'Término de Vigencia',
      key: 'nombramiento_termino_de_vigencia',
      dataIndex: 'nombramiento_termino_de_vigencia',
      width: 200,
    },
    {
      titleText: 'Fecha de Emisión',
      key: 'nombramiento_fecha_de_emision',
      dataIndex: 'nombramiento_fecha_de_emision',
      width: 200,
    },
    {
      titleText: 'Estatus del Nombramiento',
      key: 'nombramiento_estado_nombramiento',
      dataIndex: 'nombramiento_estado_nombramiento',
      width: 210,
    },
    {
      titleText: 'Sueldo Mensual',
      key: 'sueldo_mensual',
      dataIndex: 'sueldo_mensual',
      width: 150,
      render: (val) => (val != null ? currencyFormatter(val) : '-'),
    },
    {
      titleText: 'Prestaciones',
      dataIndex: 'prestaciones_para_nombramiento_descripcion',
      key: 'prestaciones_para_nombramiento_descripcion',
      width: 200,

    },
    {
      titleText: 'RFC',
      dataIndex: 'RFC',
      key: 'RFC',
      width: 200,
    },
    {
      titleText: 'CURP',
      dataIndex: 'curp',
      key: 'curp',
      width: 200,
    },
    {
      titleText: 'Edad',
      dataIndex: 'edad',
      key: 'edad',
      width: 100,

    },
    {
      titleText: 'Género',
      key: 'genero',
      dataIndex: 'genero',
      width: 200,

    },
    {
      titleText: 'Nacionalidad',
      key: 'nacionalidad',
      dataIndex: 'nacionalidad',
      width: 200,
    },
    {
      titleText: 'Lugar y Fecha de Nacimiento',
      dataIndex: 'lugar_nacimiento_estado',
      key: 'lugar_nacimiento_estado',
      width: 250,

    },
    {
      titleText: 'Calle y Número',
      dataIndex: 'calle_principal',
      key: 'calle_principal',
      width: 200,
      render: (val, record) => {
        const calle = record.calle_principal || '';
        const ext = record.numero_exterior || '';
        const int = record.numero_interior ? ` Int. ${record.numero_interior}` : '';
        return `${calle} ${ext}${int}`.trim() || '-';
      },
    },
    {
      titleText: 'Colonia',
      key: 'colonia',
      dataIndex: 'colonia',
      width: 200,
    },
    {
      titleText: 'Localidad',
      key: 'lugar_nacimiento_localidad',
      dataIndex: 'lugar_nacimiento_localidad',
      width: 200,
    },
    {
      titleText: 'Código Postal',
      key: 'codigo_postal',
      dataIndex: 'codigo_postal',
      width: 200,
    },
    {
      titleText: 'Teléfono',
      key: 'numero_de_telefono',
      dataIndex: 'numero_de_telefono',
      width: 200,
    },
    {
      titleText: 'Tipo de Nómina',
      key: 'tipo_nomina_empleado',
      dataIndex: 'tipo_nomina_empleado',
      width: 200,
    },
    {
      titleText: 'Estado del Empleado',
      key: 'estado_global',
      dataIndex: 'estado_global',
      width: 200,
    },
  ];

  // Columnas para el tab Autorización: sin columna Firmantes
  const columnsAutorizacion = columns.filter((c) => c.key !== 'nombramiento_firmantes');

  // Columnas para tabs Vigentes, Renovación, No Vigentes y Baja:
  // Folio muestra nombramiento_id en lugar de nombramiento_folio
  const columnsConNombramientoId = [
    {
      titleText: 'Folio',
      key: 'nombramiento_id',
      dataIndex: 'nombramiento_id',
      width: 70,
      render: (val) => val || '-',
    },
    ...columns.slice(1),
  ];

  // Columnas del tab Pendientes de Firma: columnsConNombramientoId ya incluye
  // Firmantes (heredado de columns).
  const columnsPendientesDeFirma = columnsConNombramientoId;

  // Columnas para el tab Empleados (fuente: empleados-vista-optimized)
  const columnsEmpleados = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado_numero',
      key: 'empleado_numero',
      width: 100,
    },
    {
      titleText: 'Empleado',
      key: 'numero_y_nombre_completo',
      dataIndex: 'numero_y_nombre_completo',
      width: 280,
    },
    columnaFirmantes,
    {
      titleText: 'Plaza',
      key: 'plaza_clave',
      dataIndex: 'plaza_clave',
      width: 100,
      render: (val) => val || '-',
    },
    {
      titleText: 'Puesto',
      key: 'puesto_descripcion',
      dataIndex: 'puesto_descripcion',
      width: 220,
      render: (val) => val || '-',
    },
    {
      titleText: 'Área',
      key: 'directorio_area_nombre',
      dataIndex: 'directorio_area_nombre',
      width: 250,
      render: (val) => val || '-',
    },
    {
      titleText: 'Tipo de Contratación',
      key: 'tipo_de_contratacion_descripcion',
      dataIndex: 'tipo_de_contratacion_descripcion',
      width: 200,
      render: (val) => val || '-',
    },
    {
      titleText: 'Tipo de Nómina',
      key: 'tipo_nomina_empleado',
      dataIndex: 'tipo_nomina_empleado',
      width: 180,
      render: (val) => val || '-',
    },
    {
      titleText: 'Estado del Empleado',
      key: 'estado_del_empleado',
      dataIndex: 'estado_del_empleado',
      width: 180,
      render: (val) => val || '-',
    },
    {
      titleText: 'Sueldo Mensual',
      key: 'sueldo_mensual',
      dataIndex: 'sueldo_mensual',
      width: 150,
      render: (val) => (val != null ? currencyFormatter(val) : '-'),
    },
    {
      titleText: 'RFC',
      key: 'RFC',
      dataIndex: 'RFC',
      width: 160,
      render: (val) => val || '-',
    },
    {
      titleText: 'CURP',
      key: 'curp',
      dataIndex: 'curp',
      width: 200,
      render: (val) => val || '-',
    },
    {
      titleText: 'Fecha de Alta',
      key: 'fecha_de_alta',
      dataIndex: 'fecha_de_alta',
      width: 140,
      render: (val) => val || '-',
    },
    {
      titleText: 'Motivo de Alta',
      key: 'motivo_alta',
      dataIndex: 'motivo_alta',
      width: 200,
      render: (val) => val || '-',
    },
  ];

  const columnsBitacoraFirma = [
    {
      title: 'Fecha',
      dataIndex: 'fecha_de_creacion',
      key: 'fecha_de_creacion',
      width: 180,
      render: (val) => (val ? dayjs(val).format('DD/MM/YYYY HH:mm:ss') : '-'),
      sorter: (a, b) => (a.fecha_de_creacion || '').localeCompare(b.fecha_de_creacion || ''),
    },
    {
      title: 'Usuario',
      dataIndex: 'usuario_nombre',
      key: 'usuario_nombre',
      width: 220,
      render: (val) => val || '-',
    },
    {
      title: 'Folio Nombramiento',
      dataIndex: 'nombramiento_folio',
      key: 'nombramiento_folio',
      width: 180,
      render: (val) => val || '-',
    },
    {
      title: 'FEA Documento ID',
      dataIndex: 'fea_documento_id',
      key: 'fea_documento_id',
      width: 280,
      render: (val) => val || '-',
    },
    {
      title: 'Tipo de Evento',
      dataIndex: 'tipo_evento',
      key: 'tipo_evento',
      width: 140,
      render: (val) => {
        if (val === 'cancelacion') return <Tag color="red">Cancelación</Tag>;
        if (val === 'error') return <Tag color="volcano">Error</Tag>;
        return <Tag color="green">Firma</Tag>;
      },
      filters: [
        { text: 'Firma', value: 'firma' },
        { text: 'Cancelación', value: 'cancelacion' },
        { text: 'Error', value: 'error' },
      ],
      onFilter: (value, record) => record.tipo_evento === value,
    },
    {
      title: 'Operación',
      dataIndex: 'operacion',
      key: 'operacion',
      width: 140,
      render: (val) => {
        const labels = {
          firma: 'Firma',
          cancelacion: 'Cancelación',
          subir_pdf: 'Subir PDF',
          consulta: 'Consulta',
        };
        return val ? (labels[val] || val) : '-';
      },
    },
    {
      title: 'Detalle',
      dataIndex: 'detalle_error',
      key: 'detalle_error',
      width: 350,
      ellipsis: { showTitle: true },
      render: (val) => val || '-',
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const handleBuscarClick = () => {
    const filtros = form.getFieldsValue();
    onBuscar(filtros);
    setIsModalVisible(false);
  };

  const handleLimpiarClick = async () => {
    setSelectedRowKeys([]);
    form.resetFields();
    setCurrentFilters(null);
    await fetchData(); // repuebla fullData y filteredData
    setIsModalVisible(false);
  };

  const handleCloseBuscarModal = () => {
    setIsModalVisible(false);
  };

  const getControls = () => {
    // Como vamos a sacar los filtros del modal, el botón "Buscar" ya no abrirá el modal,
    // sino que ejecutará la función directamente (o puedes omitirlo si el botón está en el form)
    const botonesComunes = {
      // onClickBuscar: showModal,
      onClickLimpiar: handleLimpiarClick,
      // onClickExportar: () => tuFuncionExportar() // Agrega exportar aquí si lo necesitas en todos lados
    };
    let controlesEspecificos = {};

    switch (activeTab) {
      case TAB_EMPLEADOS:
        controlesEspecificos = {
          onClickAdd, // Agrega caracter, inicio y termino
          onClickEdit,
        };
        break;
      case TAB_AUTORIZACION:
        controlesEspecificos = {
          onClickAutorizar,
          onClickEdit,
          onClickDelete: onClickDeleteNombramiento,
        };
        break;
      case TAB_PENDIENTE_FIRMA:
        controlesEspecificos = {
          onClickEdit,
          onClickDelete: onClickDeleteNombramiento,
        };
        break;
      case TAB_VIGENTES:
        controlesEspecificos = {
          onClickBaja,
          onClickEdit,
          // Agrega aquí onClickCancelar si tienes la función
        };
        break;
      case TAB_RENOVACION:
        controlesEspecificos = {
          onClickRenovar,
          onClickBaja,
          onClickEdit,
        };
        break;
      case TAB_NO_VIGENTES_PENDIENTES:
        controlesEspecificos = {
          onClickBaja,
          onClickEdit,
        };
        break;
      case TAB_NO_VIGENTES:
        controlesEspecificos = {
          onClickEdit,
        };
        break;
      case TAB_BAJA:
        controlesEspecificos = {
          onClickEdit,
        };
        break;
      default:
        break;
    }

    if (isBlocked) {
      return {
        ...botonesComunes,
        ...controlesEspecificos,
        onClickDelete: () => onAlert(`El Tipo de Nómina Empleado ${nominaDisplay} se encuentra cerrado`),
      };
    }

    return { ...botonesComunes, ...controlesEspecificos };
  };

  const generarOpcionesUnicas = (datos, campoId, campoDescripcion) => Array.from(
    new Map(
      datos
        .filter((e) => e[campoId] && e[campoDescripcion])
        .map((e) => [e[campoId], {
          id: e[campoId],
          descripcion: e[campoDescripcion].trim?.() || e[campoDescripcion],
        }]),
    ).values(),
  );

  const opcionesCaracterNombramiento = generarOpcionesUnicas(originalData, 'caracter_de_nombramiento_id', 'caracter_de_nombramiento');
  const opcionesPlaza = generarOpcionesUnicas(originalData, 'plaza_id', 'plaza');
  const opcionesArea = generarOpcionesUnicas(originalData, 'directorio_area', 'directorio_area');
  const opcionesPuesto = generarOpcionesUnicas(originalData, 'puesto_id', 'puesto');
  const opcionesEstatus = generarOpcionesUnicas(originalData, 'estado_del_empleado', 'estado_del_empleado');
  const opcionesCategoriaEmpleado = generarOpcionesUnicas(originalData, 'categoria_de_empleado_id', 'categoria_de_empleado');

  // const opcionesCaracterNombramiento = Array.from(
  //   new Map(
  //     originalData
  //       .filter((e) => e.caracter_de_nombramiento_id && e.caracter_de_nombramiento)
  //       .map((e) => [e.caracter_de_nombramiento_id, {
  //         id: e.caracter_de_nombramiento_id,
  //         descripcion: e.caracter_de_nombramiento,
  //       }]),
  //   ).values(),
  // );

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <>
            {/* Formulario de búsqueda principal */}
            <Modal
              open={isModalVisible}
              width="40%"
              closable={false}
              maskClosable={!loading}
              keyboard={!loading}
              footer={null}
              title={(
                <FormSubmitControls
                  label="Buscar Empleados"
                  onFinish={handleBuscarClick}
                  onCancel={handleCloseBuscarModal}
                  loading={loading}
                />
              )}
              forceRender
            >
              <Form layout="vertical" form={form}>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item name="numeroEmpleado" label="Número de Empleado">
                      <Input placeholder="" allowClear />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item name="nombreCompleto" label="Nombre Completo">
                      <Input placeholder="" allowClear />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item name="folio" label="Folio de Nombramiento">
                      <Input placeholder="" />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item name="fechaEmision" label="Fecha Emisión">
                      <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} placeholder="" />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item name="vigenciaInicio" label="Vigencia Inicial">
                      <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} placeholder="" />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item name="vigenciaFin" label="Vigencia Final">
                      <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} placeholder="" />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="plaza"
                      label="Plaza"
                    >
                      <Select
                        dataSource={opcionesPlaza}
                        keyProp="id"
                        labelProp="descripcion"
                        allowClear
                        placeholder=""
                      />
                    </Form.Item>

                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="directorio_area"
                      label="Área"
                    >
                      <Select
                        dataSource={opcionesArea}
                        keyProp="id"
                        labelProp="descripcion"
                        allowClear
                        placeholder=""
                      />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="puesto"
                      label="Puesto"
                    >
                      <Select
                        dataSource={opcionesPuesto}
                        keyProp="id"
                        labelProp="descripcion"
                        allowClear
                        placeholder=""
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      name="categoria_de_empleado"
                      label="Categoría de Empleado"
                    >
                      <Select
                        dataSource={opcionesCategoriaEmpleado}
                        keyProp="id"
                        labelProp="descripcion"
                        allowClear
                        placeholder=""
                      />
                    </Form.Item>

                  </Col>

                  <Col span={12}>
                    <Form.Item name="estatus" label="Estatus">
                      <Select
                        dataSource={opcionesEstatus}
                        keyProp="id"
                        labelProp="descripcion"
                        allowClear
                        placeholder=""
                      />
                    </Form.Item>

                  </Col>
                </Row>

              </Form>
            </Modal>
            {/* Tabla de empleados */}
            <Card bordered={false} className="tables-container">
              <Tabs
                activeKey={activeTab}
                onChange={setActiveTab}
                items={[
                  {
                    key: TAB_TIPODECONTRATACION,
                    label: 'Tipo de Contratación',
                    children: (
                      <NombramientosTipoContratacion
                        // IdParent={selectedRowKeys[0]}
                        setUpdateTable={setUpdateFetch}
                        permission={getModelPermission(
                          NombramientosTipoContratacionPermission.permissionModel,
                        )}
                      />
                    ),
                  },
                  {
                    key: TAB_EMPLEADOS,
                    label: 'Empleados',
                    children: (
                      <>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                          <FiltroTipoContratacion />
                        </div>
                        <Table
                          cols={columnsEmpleados}
                          data={dataFiltradaPorTipoContratacion}
                          pagination
                          rowSelection={rowSelection}
                          onTableChange={handleTableChange}
                          handleOnRowClick={handleOnRowClick}
                          controls={getControls()}
                          permission={permission}
                          allowExportPDF={false}
                          baseURI={baseURI}
                        />
                      </>
                    ),
                  },
                  {
                    key: TAB_AUTORIZACION,
                    label: 'Autorización',
                    children: (
                      <>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                          <FiltroTipoContratacion />
                        </div>
                        <Table
                          cols={columnsAutorizacion}
                          data={dataFiltradaPorTipoContratacion}
                          pagination
                          rowKey="nombramiento_id"
                          rowSelection={rowSelection}
                          onTableChange={handleTableChange}
                          handleOnRowClick={handleOnRowClick}
                          controls={getControls()}
                          permission={permission}
                          allowExportPDF={false}
                          baseURI={baseURI}
                        />
                      </>
                    ),
                  },
                  {
                    key: TAB_PENDIENTE_FIRMA,
                    label: 'Firma',
                    children: (
                      <Tabs
                        activeKey={subTabFirma}
                        onChange={setSubTabFirma}
                        items={[
                          {
                            key: SUBTAB_FIRMA_PENDIENTES,
                            label: 'Pendientes por Firmar/Autorizar',
                            children: (
                              <>
                                {firmanteFEAInfo && !firmanteFEAInfo.existeConfiguracion && (
                                  <Alert
                                    type="warning"
                                    showIcon
                                    message="Configuración de firmantes FEA pendiente"
                                    description="No hay ningún firmante autorizado configurado para Firma Electrónica (FEA) de Nombramientos. Configure al menos uno en Configuración > Accesos > Limitación de Autorización de Nombramientos."
                                    style={{ marginBottom: 12 }}
                                  />
                                )}
                                <div style={{
                                  display: 'flex', justifyContent: 'flex-end', gap: 12, marginBottom: 12,
                                }}
                                >
                                  <AntSelect
                                    value={filtroFirmante}
                                    onChange={handleFiltroFirmanteChange}
                                    options={opcionesFiltroFirmante}
                                    style={{ minWidth: 300 }}
                                  />
                                  <FiltroTipoContratacion />
                                </div>
                                <Table
                                  cols={columnsPendientesDeFirma}
                                  data={dataFiltradaPorTipoContratacion}
                                  pagination
                                  rowKey="nombramiento_id"
                                  rowSelection={rowSelection}
                                  onTableChange={handleTableChange}
                                  handleOnRowClick={handleOnRowClick}
                                  controls={getControls()}
                                  permission={permission}
                                  customActions={[
                                    {
                                      onClick: onClickFirmar,
                                      icon: <SafetyCertificateOutlined />,
                                      text: 'Firmar (FEA)',
                                      disabled: selectedRowKeys.length === 0 || !firmanteFEAInfo?.puedeFirmar || todosYaFirmadosPorUsuario,
                                    },
                                    {
                                      onClick: onClickConsultarFEA,
                                      icon: <InfoCircleOutlined />,
                                      text: 'Consultar FEA',
                                      disabled: selectedRowKeys.length !== 1,
                                      permission: { model: 'nombramiento', action: 'consultarfea' },
                                    },
                                  ]}
                                  allowExportPDF={false}
                                  baseURI={baseURI}
                                />
                              </>
                            ),
                          },
                          {
                            key: SUBTAB_FIRMA_IMPRIMIR,
                            label: 'Pendientes Imprimir',
                            children: (
                              <>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                                  <FiltroTipoContratacion />
                                </div>
                                <Table
                                  cols={columnsConNombramientoId}
                                  data={dataFiltradaPorTipoContratacion}
                                  pagination
                                  rowKey="nombramiento_id"
                                  rowSelection={rowSelection}
                                  onTableChange={handleTableChange}
                                  handleOnRowClick={handleOnRowClick}
                                  controls={getControls()}
                                  permission={permission}
                                  customActions={[
                                    {
                                      onClick: onClickPreview,
                                      icon: <EyeOutlined />,
                                      text: 'Ver Reporte',
                                      disabled: selectedRowKeys.length === 0,
                                    },
                                    {
                                      onClick: onClickImprimir,
                                      icon: <PrinterOutlined />,
                                      text: 'Marcar como Impreso',
                                      permission: { model: 'nombramiento', action: 'imprimir' },
                                      disabled: selectedRowKeys.length === 0,
                                    },
                                    {
                                      onClick: onClickConsultarFEA,
                                      icon: <InfoCircleOutlined />,
                                      text: 'Consultar FEA',
                                      disabled: selectedRowKeys.length !== 1,
                                      permission: { model: 'nombramiento', action: 'consultarfea' },
                                    },
                                    {
                                      onClick: onClickSubirPdfFEA,
                                      icon: <FilePdfOutlined />,
                                      text: 'Subir PDF a FEA',
                                      disabled: selectedRowKeys.length !== 1,
                                      permission: { model: 'nombramiento', action: 'subirpdffea' },
                                    },
                                  ]}
                                  allowExportPDF={false}
                                  baseURI={baseURI}
                                />
                              </>
                            ),
                          },
                        ]}
                      />
                    ),
                  },
                  {
                    key: TAB_VIGENTES,
                    label: 'Vigentes',
                    children: (
                      <>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                          <FiltroTipoContratacion />
                        </div>
                        <Table
                          cols={columnsConNombramientoId}
                          data={dataFiltradaPorTipoContratacion}
                          pagination
                          rowKey="nombramiento_id"
                          rowSelection={rowSelection}
                          onTableChange={handleTableChange}
                          handleOnRowClick={handleOnRowClick}
                          controls={getControls()}
                          permission={permission}
                          customActions={[
                            {
                              onClick: onClickPreview,
                              icon: <EyeOutlined />,
                              text: 'Ver Reporte',
                              disabled: selectedRowKeys.length === 0,
                            },
                            {
                              onClick: onClickAdjuntarEvidencia,
                              icon: <FilePdfOutlined />,
                              text: 'Adjuntar Evidencia',
                              disabled: selectedRowKeys.length !== 1,
                            },
                            {
                              onClick: onClickDescargarEvidencia,
                              icon: <DownloadOutlined />,
                              text: 'Descargar Evidencia',
                              disabled: selectedRowKeys.length !== 1,
                            },
                            {
                              onClick: onClickConsultarFEA,
                              icon: <InfoCircleOutlined />,
                              text: 'Consultar FEA',
                              disabled: selectedRowKeys.length !== 1,
                              permission: { model: 'nombramiento', action: 'consultarfea' },
                            },
                            {
                              onClick: onClickSubirPdfFEA,
                              icon: <FilePdfOutlined />,
                              text: 'Subir PDF a FEA',
                              disabled: selectedRowKeys.length !== 1,
                              permission: { model: 'nombramiento', action: 'subirpdffea' },
                            },
                            ...(hasActionPermission('nombramiento', 'verificarterminodevigencia') ? [{
                              onClick: handleValidarVigencia,
                              icon: <FieldTimeOutlined />,
                              text: 'Verificar Término de Vigencia',
                              disabled: isModalProgresoVisible,
                            }] : []),
                          ]}
                          allowExportPDF={false}
                          baseURI={baseURI}
                        />
                      </>
                    ),
                  },
                  {
                    key: TAB_RENOVACION,
                    label: 'Renovación',
                    children: (
                      <>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                          <FiltroTipoContratacion />
                        </div>
                        <Table
                          cols={columnsConNombramientoId}
                          data={dataFiltradaPorTipoContratacion}
                          pagination
                          rowKey="nombramiento_id"
                          rowSelection={rowSelection}
                          onTableChange={handleTableChange}
                          handleOnRowClick={handleOnRowClick}
                          controls={getControls()}
                          permission={permission}
                          customActions={[
                            {
                              onClick: onClickConsultarFEA,
                              icon: <InfoCircleOutlined />,
                              text: 'Consultar FEA',
                              disabled: selectedRowKeys.length !== 1,
                              permission: { model: 'nombramiento', action: 'consultarfea' },
                            },
                            {
                              onClick: onClickSubirPdfFEA,
                              icon: <FilePdfOutlined />,
                              text: 'Subir PDF a FEA',
                              disabled: selectedRowKeys.length !== 1,
                              permission: { model: 'nombramiento', action: 'subirpdffea' },
                            },
                          ]}
                          allowExportPDF={false}
                          baseURI={baseURI}
                        />
                      </>
                    ),
                  },
                  {
                    key: TAB_NO_VIGENTES_PENDIENTES,
                    label: 'No Vigentes (Pendientes para Baja)',
                    children: (
                      <>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                          <FiltroTipoContratacion />
                        </div>
                        <Table
                          cols={columnsConNombramientoId}
                          data={dataFiltradaPorTipoContratacion}
                          pagination
                          rowKey="nombramiento_id"
                          rowSelection={rowSelection}
                          onTableChange={handleTableChange}
                          handleOnRowClick={handleOnRowClick}
                          controls={getControls()}
                          permission={permission}
                          customActions={[
                            {
                              onClick: onClickConsultarFEA,
                              icon: <InfoCircleOutlined />,
                              text: 'Consultar FEA',
                              disabled: selectedRowKeys.length !== 1,
                              permission: { model: 'nombramiento', action: 'consultarfea' },
                            },
                            {
                              onClick: onClickSubirPdfFEA,
                              icon: <FilePdfOutlined />,
                              text: 'Subir PDF a FEA',
                              disabled: selectedRowKeys.length !== 1,
                              permission: { model: 'nombramiento', action: 'subirpdffea' },
                            },
                          ]}
                          allowExportPDF={false}
                          baseURI={baseURI}
                        />
                      </>
                    ),
                  },
                  {
                    key: TAB_NO_VIGENTES,
                    label: 'No Vigentes',
                    children: (
                      <>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                          <FiltroTipoContratacion />
                        </div>
                        <Table
                          cols={columnsConNombramientoId}
                          data={dataFiltradaPorTipoContratacion}
                          pagination
                          rowKey="nombramiento_id"
                          rowSelection={rowSelection}
                          onTableChange={handleTableChange}
                          handleOnRowClick={handleOnRowClick}
                          controls={getControls()}
                          permission={permission}
                          customActions={[
                            {
                              onClick: onClickConsultarFEA,
                              icon: <InfoCircleOutlined />,
                              text: 'Consultar FEA',
                              disabled: selectedRowKeys.length !== 1,
                              permission: { model: 'nombramiento', action: 'consultarfea' },
                            },
                          ]}
                          allowExportPDF={false}
                          baseURI={baseURI}
                        />
                      </>
                    ),
                  },
                  {
                    key: TAB_BAJA,
                    label: 'Baja',
                    children: (
                      <>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                          <FiltroTipoContratacion />
                        </div>
                        <Table
                          cols={columnsConNombramientoId}
                          data={dataFiltradaPorTipoContratacion}
                          pagination
                          rowKey="nombramiento_id"
                          rowSelection={rowSelection}
                          onTableChange={handleTableChange}
                          handleOnRowClick={handleOnRowClick}
                          controls={getControls()}
                          permission={permission}
                          customActions={[
                            {
                              onClick: onClickConsultarFEA,
                              icon: <InfoCircleOutlined />,
                              text: 'Consultar FEA',
                              disabled: selectedRowKeys.length !== 1,
                              permission: { model: 'nombramiento', action: 'consultarfea' },
                            },
                          ]}
                          allowExportPDF={false}
                          baseURI={baseURI}
                        />
                      </>
                    ),
                  },
                  {
                    key: TAB_BITACORA_FIRMA,
                    label: 'Bitácora Firma',
                    children: (
                      <Spin spinning={loadingBitacora}>
                        <AntTable
                          columns={columnsBitacoraFirma}
                          dataSource={dataBitacora}
                          rowKey="id"
                          size="small"
                          pagination={{ pageSize: 20, showSizeChanger: true }}
                          scroll={{ x: 1000 }}
                        />
                      </Spin>
                    ),
                  },
                  {
                    key: TAB_IMPRIMIR,
                    label: 'Imprimir',
                    children: (
                      <ReportViewer reportId={10001} height="calc(100vh - 320px)" />
                    ),
                  },
                ]}
              />
            </Card>
            <Modal
              open={isModalNombramientoMasivoVisible}
              closable={false}
              maskClosable={!loading}
              keyboard={!loading}
              footer={null}
              forceRender
              width={680}
              title={(
                <FormSubmitControls
                  label="Agregar Nombramiento Masivo"
                  onFinish={() => formNombramiento.submit()}
                  onCancel={() => {
                    setIsModalNombramientoMasivoVisible(false);
                    formNombramiento.resetFields();
                    setPeriodosNombramiento([]);
                  }}
                  loading={loading}
                />
              )}
            >
              <Form
                layout="vertical"
                form={formNombramiento}
                onFinish={onFinish}
                onValuesChange={onNombramientoFieldChange}
              >
                <Row gutter={16}>
                  <Col span={24}>
                    <p>
                      <strong>Empleados seleccionados:</strong>
                      {' '}
                      {selectedRowKeys.length}
                    </p>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="caracter_de_nombramiento"
                      label="Carácter de Nombramiento"
                      rules={[{ required: true, message: 'Selecciona el carácter' }]}
                    >
                      <Select
                        dataSource={caracterdenombramiento}
                        keyProp="id"
                        labelProp="descripcion"
                        allowClear
                        placeholder="Selecciona un carácter"
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      name="inicio_vigencia"
                      label="Inicio de Vigencia"
                      rules={[{ required: true, message: 'Selecciona la fecha de inicio' }]}
                    >
                      <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      name="termino_vigencia"
                      label="Término de Vigencia"
                      rules={[{ required: true, message: 'Selecciona la fecha de término' }]}
                    >
                      <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="periodicidad"
                      label="Periodicidad"
                      extra="Selecciona una periodicidad para generar nombramientos por período. Deja vacío para un solo nombramiento."
                    >
                      <AntSelect
                        allowClear
                        placeholder="Sin periodicidad (un solo nombramiento)"
                        options={PERIODICIDAD_OPCIONES}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="tipo_de_movimiento"
                      label="Tipo de Movimiento de Personal"
                    >
                      <Select
                        dataSource={tiposDeMovimientoDePersonal}
                        keyProp="id"
                        labelProp="concepto"
                        allowClear
                        placeholder="Selecciona un tipo de movimiento"
                      />
                    </Form.Item>
                  </Col>

                  {periodosNombramiento.length > 0 && (
                    <Col span={24}>
                      <AntTable
                        size="small"
                        pagination={false}
                        dataSource={periodosNombramiento}
                        rowKey="key"
                        title={() => (
                          <Typography.Text strong>
                            {`Períodos a generar: ${periodosNombramiento.length}`}
                          </Typography.Text>
                        )}
                        columns={[
                          {
                            title: '#',
                            key: 'num',
                            width: 50,
                            align: 'center',
                            render: (_v, _r, i) => i + 1,
                          },
                          {
                            title: 'Fecha Inicial',
                            dataIndex: 'inicio',
                            render: (val, record) => (
                              <DatePicker
                                size="small"
                                format="YYYY-MM-DD"
                                value={moment(val)}
                                style={{ width: '100%' }}
                                getPopupContainer={(t) => t.parentNode}
                                onChange={(date) => {
                                  if (!date) return;
                                  setPeriodosNombramiento((prev) => prev.map((item) => (
                                    item.key === record.key
                                      ? { ...item, inicio: date.format('YYYY-MM-DD') }
                                      : item
                                  )));
                                }}
                              />
                            ),
                          },
                          {
                            title: 'Fecha Final',
                            dataIndex: 'fin',
                            render: (val, record) => (
                              <DatePicker
                                size="small"
                                format="YYYY-MM-DD"
                                value={moment(val)}
                                style={{ width: '100%' }}
                                getPopupContainer={(t) => t.parentNode}
                                onChange={(date) => {
                                  if (!date) return;
                                  setPeriodosNombramiento((prev) => prev.map((item) => (
                                    item.key === record.key
                                      ? { ...item, fin: date.format('YYYY-MM-DD') }
                                      : item
                                  )));
                                }}
                              />
                            ),
                          },
                        ]}
                      />
                    </Col>
                  )}
                </Row>
              </Form>
            </Modal>
            <Modal
              width="50%"
              open={isModalAutorizarVisible}
              closable={false}
              maskClosable={!loading}
              keyboard={!loading}
              footer={null}
              forceRender
              title={(
                <FormSubmitControls
                  label="Autorizar Nombramientos"
                  onFinish={() => formAutorizar.submit()}
                  onCancel={() => {
                    setIsModalAutorizarVisible(false);
                    formAutorizar.resetFields();
                  }}
                  loading={loading}
                />
              )}
            >
              <Form
                layout="vertical"
                form={formAutorizar}
                onFinish={onAutorizarFinish}
              >
                <Row gutter={16}>
                  <Col span={24}>
                    <p>
                      Se autorizarán:
                      <strong>
                        {' '}
                        {selectedRowKeys.length}
                        {' '}
                      </strong>
                      registro(s)
                    </p>
                  </Col>

                  {/* Campos de Emisión */}
                  <Col span={8}>
                    <Form.Item
                      name="fecha_emision"
                      label="Fecha de Emisión"
                      rules={[{ required: true, message: 'Selecciona la fecha' }]}
                    >
                      <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      name="hora_emision"
                      label="Hora de Emisión"
                      rules={[{ required: true, message: 'Selecciona la hora' }]}
                    >
                      <TimePicker format="HH:mm:ss" style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      name="lugar_emision"
                      label="Lugar de Emisión"
                      rules={[{ required: true, message: 'Escribe el lugar' }]}
                    >
                      <Input placeholder="Ej. Tlajomulco de Zúñiga" />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="observaciones"
                      label="Observaciones de autorización"
                      rules={[{
                        required: requiereObservacionesNombramiento,
                        message: 'Las observaciones son requeridas para este paso de autorización',
                        whitespace: true,
                      }]}
                    >
                      <Input.TextArea
                        rows={4}

                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Modal>
            <Modal
              width="50%"
              open={isModalRenovarVisible}
              closable={false}
              maskClosable={!loading}
              keyboard={!loading}
              footer={null}
              forceRender
              title={(
                <FormSubmitControls
                  label="Renovar Nombramientos"
                  onFinish={() => formRenovar.submit()}
                  onCancel={() => {
                    setIsModalRenovarVisible(false);
                    formRenovar.resetFields();
                  }}
                  loading={loading}
                />
              )}
            >
              <Form
                layout="vertical"
                form={formRenovar}
                onFinish={onRenovarFinish}
              >
                <Row gutter={16}>
                  <Col span={24}>
                    <p>
                      <strong>Empleados seleccionados:</strong>
                      {' '}
                      {selectedRowKeys.length}
                    </p>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      name="inicio_vigencia"
                      label="Inicio de Vigencia"
                      rules={[{ required: true, message: 'Selecciona la fecha de inicio' }]}
                    >
                      <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>

                  <Form.Item
                    name="termino_vigencia"
                    label="Término de Vigencia"
                    dependencies={['inicio_vigencia']}
                    rules={[
                      { required: true, message: 'Selecciona la fecha de término' },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const inicio = getFieldValue('inicio_vigencia');
                          if (!inicio || !value || value.isSameOrAfter(inicio)) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('La fecha de término no puede ser anterior a la de inicio.'));
                        },
                      }),
                    ]}
                  >
                    <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
                  </Form.Item>

                  <Col span={6}>
                    <Form.Item
                      name="fecha_emision"
                      label="Fecha de Emisión"
                      rules={[{ required: true, message: 'Selecciona la fecha' }]}
                    >
                      <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      name="hora_emision"
                      label="Hora de Emisión"
                      rules={[{ required: true, message: 'Selecciona la hora' }]}
                    >
                      <TimePicker format="HH:mm:ss" style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      name="lugar_emision"
                      label="Lugar de Emisión"
                      rules={[{ required: true, message: 'Escribe el lugar' }]}
                    >
                      <Input placeholder="Ej. Tepic, Nayarit" />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Modal>

            <Modal
              open={isModalBajaVisible}
              closable={false}
              maskClosable={!loading}
              keyboard={!loading}
              footer={null}
              forceRender
              title={(
                <FormSubmitControls
                  label="Dar de Baja Nombramientos"
                  onFinish={() => formBaja.submit()}
                  onCancel={() => {
                    setIsModalBajaVisible(false);
                    formBaja.resetFields();
                    setAplicaFiniquito(false); // Reiniciamos el estado al cerrar
                  }}
                  loading={loading}
                />
              )}
            >
              <Form
                layout="vertical"
                form={formBaja}
                onFinish={onBajaFinish}
              >
                <Row gutter={16}>
                  <Col span={24}>
                    <p>
                      <strong>Empleados seleccionados:</strong>
                      {' '}
                      {selectedRowKeys.length}
                    </p>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="nombramiento_fecha_baja"
                      label="Fecha de Baja"
                      rules={[{ required: true, message: 'Selecciona la fecha de baja' }]}
                    >
                      <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>

                  {/* Campo: ¿Aplica Finiquito? con el nuevo manejo de estado */}
                  <Col span={24}>
                    <Form.Item
                      name="aplica_finiquito"
                      label="¿Aplica Finiquito?"
                      rules={[{ required: true, message: 'Selecciona una opción' }]}
                    >
                      <Select
                        trueFalse
                        placeholder="Selecciona una opción"
                        onChange={(value) => {
                          setAplicaFiniquito(value);
                          if (!value) {
                            formBaja.setFieldsValue({ tipo_finiquito: null });
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="nombramiento_estado_nombramiento_id"
                      label="Motivo de Baja"
                      rules={[{ required: true, message: 'Selecciona el motivo de baja' }]}
                    >
                      <Select
                        dataSource={motivosBaja}
                        keyProp="id"
                        labelProp="concepto"
                        render={(value) => value?.concepto}
                        placeholder="Selecciona un motivo"
                        allowClear
                      />
                    </Form.Item>
                  </Col>

                  {/* Campo condicional: Tipo de Finiquito */}
                  {aplicaFiniquito && (
                    <Col span={24}>
                      <Form.Item
                        name="tipo_finiquito"
                        label="Tipo de Finiquito"
                        rules={[{ required: true, message: 'Selecciona el tipo de finiquito' }]}
                      >
                        <Select
                          dataSource={motivosLiquidacion}
                          keyProp="id"
                          labelProp="clave"
                          render={(item) => {
                            const motivoObj = catMotivosLiquidacion.find(
                              (m) => m.id === item?.motivo_de_liquidacion,
                            );
                            const textoMotivo = motivoObj ? motivoObj.motivo : '';
                            return ` ${item?.clave} - ${textoMotivo}`;
                          }}
                          placeholder="Selecciona el tipo"
                          allowClear
                        />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </Form>
            </Modal>

            <Modal
              open={isModalFirmarVisible}
              closable={false}
              maskClosable={!loadingFirmar}
              keyboard={!loadingFirmar}
              footer={null}
              forceRender
              title={(
                <FormSubmitControls
                  label={firmanteFEAInfo?.requiereFea
                    ? 'Firmar Nombramientos con Firma Electrónica'
                    : 'Confirmar Autorización de Nombramientos'}
                  onFinish={handleFirmarSubmit}
                  onCancel={cerrarModalFirmar}
                  loading={loadingFirmar}
                />
              )}
            >
              <Form
                layout="vertical"
                form={formFirmar}
              >
                <Row gutter={16}>
                  <Col span={24}>
                    <p>
                      <strong>Nombramientos seleccionados:</strong>
                      {' '}
                      {selectedRowKeys.length}
                    </p>
                  </Col>
                  {firmanteFEAInfo?.requiereFea ? (
                    <>
                      <Col span={24}>
                        <Form.Item
                          label="Certificado (.p12 o .cer)"
                          required
                        >
                          <Upload
                            beforeUpload={(file) => {
                              setArchivoCertificado(file);
                              // Al cambiar archivo principal, limpiar .key y contraseña previos
                              // (pueden pertenecer a un certificado distinto)
                              setArchivoKey(null);
                              formFirmar.setFieldsValue({ contrasena: undefined });
                              return false;
                            }}
                            onRemove={() => {
                              setArchivoCertificado(null);
                              setArchivoKey(null);
                              formFirmar.setFieldsValue({ contrasena: undefined });
                            }}
                            maxCount={1}
                            accept=".p12,.cer"
                            fileList={archivoCertificado ? [{ uid: '-1', name: archivoCertificado.name, status: 'done' }] : []}
                          >
                            <Button>Seleccionar Archivo</Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                      {archivoCertificado && !archivoCertificado.name.toLowerCase().endsWith('.p12') && (
                        <Col span={24}>
                          <Form.Item
                            label="Llave Privada (.key)"
                            required
                            help="Requerido cuando se usa .cer en lugar de .p12"
                          >
                            <Upload
                              beforeUpload={(file) => {
                                setArchivoKey(file);
                                return false;
                              }}
                              onRemove={() => setArchivoKey(null)}
                              maxCount={1}
                              accept=".key"
                              fileList={archivoKey ? [{ uid: '-1', name: archivoKey.name, status: 'done' }] : []}
                            >
                              <Button>Seleccionar Archivo</Button>
                            </Upload>
                          </Form.Item>
                        </Col>
                      )}
                      <Col span={24}>
                        <Form.Item
                          name="contrasena"
                          label="Contraseña del Certificado"
                          rules={[{ required: true, message: 'Ingresa la contraseña del certificado' }]}
                        >
                          <Input.Password placeholder="Contraseña" />
                        </Form.Item>
                      </Col>
                    </>
                  ) : (
                    <Col span={24}>
                      <p>
                        Tu paso de autorización no requiere Firma Electrónica. Al confirmar,
                        se registrará tu autorización para estos nombramientos.
                      </p>
                    </Col>
                  )}
                </Row>
              </Form>
            </Modal>

            <Modal
              open={isModalEvidenciaVisible}
              closable={false}
              maskClosable={!loadingEvidencia}
              keyboard={!loadingEvidencia}
              footer={null}
              forceRender
              title={(
                <FormSubmitControls
                  label="Adjuntar Evidencia de Firma"
                  onFinish={handleAdjuntarEvidenciaSubmit}
                  onCancel={() => {
                    setIsModalEvidenciaVisible(false);
                    setArchivoEvidencia(null);
                  }}
                  loading={loadingEvidencia}
                />
              )}
            >
              <Row gutter={16}>
                <Col span={24}>
                  <p>
                    Sube el PDF del Nombramiento ya firmado (escaneado o firmado fuera de
                    FEA). Si ya existe un archivo cargado, se reemplaza y el anterior queda
                    guardado en el historial del documento.
                  </p>
                </Col>
                <Col span={24}>
                  <Form.Item label="Documento (.pdf)" required>
                    <Upload
                      beforeUpload={(file) => {
                        setArchivoEvidencia(file);
                        return false;
                      }}
                      onRemove={() => setArchivoEvidencia(null)}
                      maxCount={1}
                      accept=".pdf"
                      fileList={archivoEvidencia ? [{ uid: '-1', name: archivoEvidencia.name, status: 'done' }] : []}
                    >
                      <Button>Seleccionar Archivo</Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
            </Modal>

            <Modal
              open={isModalConsultaFEAVisible}
              title="Estado del Documento en FEA"
              onCancel={() => {
                setIsModalConsultaFEAVisible(false);
                setConsultaFEAData(null);
              }}
              footer={[
                <Button
                  key="cerrar"
                  onClick={() => {
                    setIsModalConsultaFEAVisible(false);
                    setConsultaFEAData(null);
                  }}
                >
                  Cerrar
                </Button>,
              ]}
              width={700}
            >
              {(() => {
                if (loadingConsultaFEA) {
                  return (
                    <div style={{ textAlign: 'center', padding: 40 }}>
                      <Spin tip="Consultando servicio FEA..." />
                    </div>
                  );
                }
                if (consultaFEAData) {
                  return (
                    <>
                      <Row gutter={[16, 8]}>
                        <Col span={12}>
                          <Typography.Text strong>ID Documento:</Typography.Text>
                          {' '}
                          <Typography.Text copyable>
                            {consultaFEAData.fea_documento_id || '-'}
                          </Typography.Text>
                        </Col>
                        <Col span={12}>
                          <Typography.Text strong>Nombramiento:</Typography.Text>
                          {' '}
                          {consultaFEAData.nombramiento_id || '-'}
                        </Col>
                      </Row>
                      {consultaFEAData.documento_fea && (
                        <Card
                          size="small"
                          style={{ marginTop: 16 }}
                          title="Respuesta del Servicio FEA"
                        >
                          <pre style={{
                            maxHeight: 400,
                            overflow: 'auto',
                            fontSize: 12,
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-all',
                          }}
                          >
                            {JSON.stringify(consultaFEAData.documento_fea, null, 2)}
                          </pre>
                        </Card>
                      )}
                      {consultaFEAData.message && !consultaFEAData.documento_fea && (
                        <Alert
                          type="warning"
                          showIcon
                          message={consultaFEAData.message}
                          style={{ marginTop: 16 }}
                        />
                      )}
                    </>
                  );
                }
                return <Empty description="Sin datos disponibles" />;
              })()}
            </Modal>

            <Modal
              open={isModalSubirPdfFEAVisible}
              closable={false}
              maskClosable={!loadingSubirPdfFEA}
              keyboard={!loadingSubirPdfFEA}
              footer={null}
              forceRender
              title={(
                <FormSubmitControls
                  label="Subir PDF al Servicio FEA"
                  onFinish={handleSubirPdfFEASubmit}
                  onCancel={() => {
                    setIsModalSubirPdfFEAVisible(false);
                    setArchivoPdfFEA(null);
                  }}
                  loading={loadingSubirPdfFEA}
                />
              )}
            >
              <Row gutter={16}>
                <Col span={24}>
                  <p>
                    Sube el PDF del Nombramiento ya firmado para asociarlo al documento
                    registrado en el servicio de Firma Electrónica Avanzada (FEA).
                    El documento debe haberse firmado electrónicamente previamente.
                  </p>
                </Col>
                <Col span={24}>
                  <Form.Item label="Documento (.pdf)" required>
                    <Upload
                      beforeUpload={(file) => {
                        setArchivoPdfFEA(file);
                        return false;
                      }}
                      onRemove={() => setArchivoPdfFEA(null)}
                      maxCount={1}
                      accept=".pdf"
                      fileList={archivoPdfFEA ? [{ uid: '-1', name: archivoPdfFEA.name, status: 'done' }] : []}
                    >
                      <Button>Seleccionar Archivo</Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
            </Modal>

          </>
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Empleado ${selectedRowKeys.length ? `"${form.getFieldValue('numero_y_nombre_completo') || ''}"` : ''}`}
            extra={(
              <FormSubmitControls
                onFinish={puedeEditarNombramiento ? onFinishEditarNombramiento : undefined}
                onCancel={onCancelWithFetch}
                loading={loading}
                onFinishText="Guardar"
              />
            )}
            bordered={false}
          >
            <p>
              <strong>Empleados seleccionados:</strong>
              {' '}
              {selectedRowKeys.length}
            </p>
            <Tabs
              type="card"
              activeKey={currentParentTabKey || 'general'} // Evitar undefined
              onChange={setCurrentParentTabKey}
            >
              <TabPane
                tab={(
                  <span>
                    <InfoCircleOutlined />
                    {' '}
                    Datos Generales
                  </span>
                )}
                key="general"
                forceRender
              >
                <Form
                  layout="vertical"
                  form={form}
                  name="general"
                  // onFinish={() => onFinish()}
                  scrollToFirstError
                >
                  <Card
                    size="small"
                    className="inner-block-card"
                  >
                    <Row gutter={10} align="middle">
                      <Col xs={24} sm={24} md={16}>
                        <Typography.Text strong style={{ fontSize: 16, display: 'block' }}>
                          {
                            `${form.getFieldValue('numero_de_empleado') || ''} - `
                            + `${form.getFieldValue('nombre') || ''} `
                            + `${form.getFieldValue('apellido_paterno') || ''} `
                            + `${form.getFieldValue('apellido_materno') || ''}`
                          }
                        </Typography.Text>
                        <Typography.Text type="secondary">
                          {[
                            form.getFieldValue('puesto'),
                            form.getFieldValue('categoria_de_empleado'),
                          ].filter(Boolean).join(' · ')}
                        </Typography.Text>
                      </Col>
                      <Col xs={24} sm={24} md={8} style={{ textAlign: 'right' }}>
                        {form.getFieldValue('estado_nombramiento') && (
                          <Tag
                            color={
                              String(form.getFieldValue('estado_nombramiento')).toUpperCase().includes('NO')
                                || String(form.getFieldValue('estado_nombramiento')).toUpperCase().includes('CANCELADO')
                                ? 'red' : 'green'
                            }
                          >
                            {form.getFieldValue('estado_nombramiento')}
                          </Tag>
                        )}
                        <div>
                          <Typography.Text type="secondary">Folio </Typography.Text>
                          <Typography.Text strong>
                            {form.getFieldValue('nombramiento_folio')}
                          </Typography.Text>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                  <Card
                    type="inner"
                    size="small"
                    className="inner-block-card"
                    title="1. Puesto Y Plaza"
                    extra="Dónde Está Adscrito El Empleado"
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          name="plaza"
                          label="Plaza"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          name="directorio_area"
                          label="Área"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          name="puesto"
                          label="Puesto"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_empleado"
                          label="Tipo de Empleado"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="categoria_de_empleado"
                          label="Categoría de Empleado"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="jornada"
                          label="Jornada Semanal"
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                  <Card
                    type="inner"
                    size="small"
                    className="inner-block-card"
                    title="2. Contratación Y Vigencia"
                    extra="Tipo, Carácter Y Período Activo"
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_de_contratacion"
                          label="Tipo de Contratación"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="caracter_nombramiento"
                          label="Carácter de Nombramiento"
                        >
                          <Select
                            dataSource={caracterdenombramiento}
                            keyProp="id"
                            labelProp="descripcion"
                            disabled={!puedeEditarNombramiento}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_emision"
                          label="Fecha de Emisión"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="inicio_vigencia"
                          label="Inicio de Vigencia"
                        >
                          <DatePicker
                            placeholder=""
                            format="DD/MM/YYYY"
                            disabled={!puedeEditarNombramiento}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="termino_vigencia"
                          label="Término de Vigencia"
                        >
                          <DatePicker
                            format="DD/MM/YYYY"
                            style={{ width: '100%' }}
                            disabled={!puedeEditarNombramiento}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item label="Duración">
                          <Input
                            disabled
                            value={
                              (() => {
                                const inicio = form.getFieldValue('inicio_vigencia');
                                const termino = form.getFieldValue('termino_vigencia');
                                if (inicio && termino) {
                                  const dias = moment(termino).diff(moment(inicio), 'days') + 1;
                                  return dias > 0 ? `${dias} días` : '';
                                }
                                return '';
                              })()
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                  <Card
                    type="inner"
                    size="small"
                    className="inner-block-card"
                    title="3. Compensación"
                    extra="Sueldo Y Prestaciones"
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={12}>
                        <CurrencyInput
                          name="sueldo_mensual"
                          label="Sueldo Mensual"
                          disabled
                        />
                      </Col>
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          name="prestaciones"
                          label="Prestaciones"
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                  <Card
                    type="inner"
                    size="small"
                    className="inner-block-card"
                    title="4. Datos Personales"
                    extra="Identificación Fiscal Y Datos Generales"
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="RFC"
                          label="RFC"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="curp"
                          label="CURP"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estado_del_empleado"
                          label="Estatus del Empleado"
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="edad"
                          label="Edad"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="genero"
                          label="Género"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estado_civil"
                          label="Estado Civil"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="nacionalidad"
                          label="Nacionalidad"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="entidad"
                          label="Lugar de Nacimiento"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_de_telefono"
                          label="Teléfono"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item label="Calle y Número">
                          <Input
                            disabled
                            value={
                              (() => {
                                const calle = form.getFieldValue('calle_principal') || '';
                                const exterior = form.getFieldValue('numero_exterior') || '';
                                const interior = form.getFieldValue('numero_interior');
                                const tipo = interior ? `Interior ${interior}` : `Exterior ${exterior}`;
                                const result = `${calle} ${tipo}`.trim();
                                return result ? result.charAt(0).toUpperCase() + result.slice(1) : '';
                              })()
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="codigo_postal"
                          label="Código Postal"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>

                </Form>
              </TabPane>

            </Tabs>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Empleado ${form.getFieldValue('nombre')} ${form.getFieldValue('apellido_paterno')}`}
          loading={loading}
        />
        <ModalDelete
          onDelete={deleteNombramientoItem}
          onCancel={() => setVisibleAlertNombramiento(false)}
          open={visibleAlertNombramiento}
          content={
            selectedRowKeys.length === 1
              ? `el Nombramiento de ${getActiveDataSource().find((e) => getRowKey(e) === selectedRowKeys[0])?.numero_y_nombre_completo || selectedRowKeys[0]}`
              : `${selectedRowKeys.length} Nombramientos seleccionados`
          }
          loading={loading}
        />
        <Modal
          title="Dar Visto Bueno"
          open={visibleAlertVistoBueno}
          onOk={handleVistoBuenoConfirm}
          onCancel={() => setVisibleAlertVistoBueno(false)}
          okText="Confirmar Visto Bueno"
          cancelText="Cancelar"
          confirmLoading={loading}
        >
          <p>
            {`¿Desea dar visto bueno a ${selectedRowKeys.length} nombramiento(s)? `}
            Los registros pasarán al tab Vigentes.
          </p>
        </Modal>
        <Modal
          title="Vista Previa del Reporte"
          open={visiblePreview}
          onCancel={() => setVisiblePreview(false)}
          footer={null}
          width="80%"
          style={{ top: 20 }}
          destroyOnClose
        >
          <div style={{ height: '75vh', backgroundColor: '#f5f5f5', padding: '10px' }}>
            {base64 ? (
              <iframe
                src={base64}
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  backgroundColor: 'white',
                  borderRadius: '4px',
                }}
                title="Vista Previa de Nombramientos"
              />
            ) : (
              <Empty description="No hay reporte para mostrar." style={{ marginTop: '10%' }} />
            )}
          </div>
        </Modal>

        {/* Modal de progreso para operaciones masivas */}
        <Modal
          title="Procesando operación..."
          open={isModalProgresoVisible}
          footer={null}
          closable={false}
          maskClosable={false}
          width={480}
          focusTriggerAfterClose={false}
        >
          {isModalProgresoVisible && (
            <div style={{ padding: '8px 0' }}>
              {progresoActual.total > 0 ? (
                <>
                  <p style={{ marginBottom: 6, color: '#595959' }}>
                    {`Procesando ${progresoActual.en_curso} de ${progresoActual.total} registros...`}
                  </p>
                  <div
                    style={{
                      background: '#f0f0f0',
                      borderRadius: 4,
                      overflow: 'hidden',
                      height: 12,
                      marginBottom: 4,
                    }}
                  >
                    <div
                      style={{
                        height: '100%',
                        width: `${Math.round((progresoActual.en_curso / progresoActual.total) * 100)}%`,
                        background: '#1890ff',
                        borderRadius: 4,
                        transition: 'width 0.5s ease',
                      }}
                    />
                  </div>
                  <p
                    style={{
                      textAlign: 'right', fontSize: 12, color: '#8c8c8c', margin: 0,
                    }}
                  >
                    {`${Math.round((progresoActual.en_curso / progresoActual.total) * 100)}%`}
                  </p>
                </>
              ) : (
                <>
                  <p style={{ marginBottom: 8, color: '#595959' }}>
                    Por favor espere, esto puede tomar varios minutos...
                  </p>
                  <div
                    style={{
                      background: '#f0f0f0',
                      borderRadius: 4,
                      overflow: 'hidden',
                      height: 12,
                      marginBottom: 12,
                      position: 'relative',
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        height: '100%',
                        width: '40%',
                        background: '#1890ff',
                        borderRadius: 4,
                        animation: 'indeterminate 1.4s infinite ease-in-out',
                      }}
                    />
                  </div>
                  <style>
                    {'@keyframes indeterminate { 0% { left: -40%; } 100% { left: 110%; } }'}
                  </style>
                </>
              )}
            </div>
          )}
        </Modal>
      </Spin>

    </Row>
  );
};

export default ConsultasDeNombramientos;
